var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _g, _path202, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 386,
    height: 198,
    viewBox: "0 0 386 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10512_4421)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10512_4421)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 382,
    height: 194,
    rx: 24,
    fill: "#0E917A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M199.613 140.627C118.736 144.733 119.31 197.882 113 228.046V256.682L477.807 271L484.116 64.2459C496.162 1.24598 381.824 -33.0113 338.423 7.54598C293.683 49.355 301.139 135.472 199.613 140.627Z",
    fill: "#628EB3"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M219.81 165.537C220.425 160.637 224.135 152.571 225.579 142.289C227.197 130.784 224.099 117.129 224.099 117.129C224.099 117.129 218.31 131.19 216.519 142.289C214.913 152.245 216.459 161.668 215.887 165.677L219.81 165.537Z",
    fill: "url(#paint0_linear_10512_4421)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M210.142 166.022C209.597 161.616 206.412 154.41 205.177 145.321C203.812 135.274 206.42 123.51 206.42 123.51C206.42 123.51 211.318 135.624 212.876 145.321C214.293 154.123 213.01 162.539 213.52 166.15L210.142 166.022Z",
    fill: "url(#paint1_linear_10512_4421)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M219.81 165.537C220.425 160.637 224.135 152.571 225.579 142.289C227.197 130.784 224.099 117.129 224.099 117.129C224.099 117.129 218.31 131.19 216.519 142.289C214.913 152.245 216.459 161.668 215.887 165.677L219.81 165.537Z",
    fill: "#246266"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M210.142 166.022C209.597 161.616 206.412 154.41 205.177 145.321C203.812 135.274 206.42 123.51 206.42 123.51C206.42 123.51 211.318 135.624 212.876 145.321C214.293 154.123 213.01 162.539 213.52 166.15L210.142 166.022Z",
    fill: "#246266"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M216.704 165.677C216.704 160.131 219.415 150.908 219.589 138.985C219.786 125.417 214.814 109 214.814 109C214.814 109 210.717 125.899 210.37 138.985C210.062 150.533 212.856 161.298 212.801 165.832L216.704 165.673V165.677Z",
    fill: "url(#paint2_linear_10512_4421)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M222.762 165.689C223.839 160.502 228.286 151.927 230.733 140.927C233.491 128.527 231.775 113.682 231.775 113.682C231.775 113.682 224.604 128.965 221.743 140.927C219.198 151.58 219.83 161.597 218.886 165.836L222.762 165.689Z",
    fill: "url(#paint3_linear_10512_4421)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M206.669 165.705C205.663 161.151 201.551 153.694 199.341 144.259C196.89 133.789 198.548 121.488 198.548 121.488C198.548 121.488 205.004 134.156 207.616 144.259C209.98 153.396 209.408 162.11 210.296 165.836L206.669 165.705Z",
    fill: "url(#paint4_linear_10512_4421)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M198.548 121.488C198.548 121.488 199.436 135.211 202.143 144.773C204.167 151.927 208.445 161.593 209.637 165.769L206.669 165.705C205.663 161.151 201.551 153.694 199.341 144.259C196.89 133.789 198.548 121.488 198.548 121.488Z",
    fill: "#246266"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M215.887 165.677C215.615 161.895 213.211 150.131 213.389 138.26C213.614 123.3 214.814 109.004 214.814 109.004C214.814 109.004 210.717 125.903 210.37 138.989C210.062 150.537 212.856 161.302 212.801 165.836L215.887 165.677Z",
    fill: "#246266"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M221.704 165.689C222.75 160.502 222.347 151.788 224.439 140.768C226.799 128.348 231.775 113.678 231.775 113.678C231.775 113.678 224.604 128.961 221.743 140.923C219.198 151.577 219.83 161.593 218.886 165.832L221.7 165.685L221.704 165.689Z",
    fill: "#246266"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M201.519 130.959C200.576 131.15 201.488 136.918 202.948 142.289C204.27 147.141 206.037 151.668 207.3 151.445C209.956 150.971 203.082 130.644 201.519 130.959Z",
    fill: "#47B3AA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M230.729 124.023C229.81 123.745 227.805 131.042 226.59 136.472C225.493 141.38 224.881 148.164 226.1 148.562C227.268 148.948 229.324 143.383 230.338 137.809C231.546 131.169 231.558 124.274 230.729 124.023Z",
    fill: "#47B3AA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M215.706 119.219C214.329 119.247 214.06 145.688 216.981 145.772C219.901 145.855 217.431 119.187 215.706 119.219Z",
    fill: "#47B3AA"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M208.551 191.287H220.603C223.867 184.877 226.522 176.41 228.543 164.781H200.608C202.778 177.186 205.414 185.486 208.548 191.287H208.551Z",
    fill: "url(#paint5_linear_10512_4421)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M200.955 166.7C200.837 166.071 200.722 165.434 200.608 164.781H228.543C228.428 165.43 228.314 166.071 228.2 166.7H200.955Z",
    fill: "#D8CCFF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M210.919 164.781C210.919 164.781 211.87 180.896 214.656 191.287H208.548C205.414 185.486 202.778 177.19 200.608 164.781H210.919Z",
    fill: "#60578F"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M364.344 81.5794L298.238 148.268L300.348 150.396L366.454 83.7078L364.344 81.5794Z",
    fill: "url(#paint6_linear_10512_4421)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M298.818 147.682L361.277 84.6723L364.346 81.5762L365.148 82.3849L366.457 83.7057L363.189 87.0029C362.809 86.5052 362.42 86.0218 362.022 85.5385L299.686 148.424C300.165 148.826 300.644 149.218 301.137 149.601L300.355 150.391L298.249 148.261L298.827 147.677L298.818 147.682Z",
    fill: "#9E4435"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M326.572 181.998H331.961V159.416H326.572V181.998Z",
    fill: "url(#paint7_linear_10512_4421)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M329.267 153.764C351.648 153.764 369.792 135.46 369.792 112.882C369.792 90.3035 351.648 72 329.267 72C306.886 72 288.742 90.3035 288.742 112.882C288.742 135.46 306.886 153.764 329.267 153.764Z",
    fill: "url(#paint8_linear_10512_4421)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M333.513 125.065C335.951 123.496 339.362 123.611 341.914 121.979C343.223 121.141 344.456 119.993 345.647 119.045C346.501 118.366 347.364 117.04 348.365 116.346C349.727 115.404 350.471 116.203 351.966 115.911C353.374 115.638 354.024 114.71 355.699 114.868C355.329 115.241 355.637 114.738 355.528 115.461C356.809 115.786 358.488 117.911 358.616 119.04C358.725 120.007 357.848 121.041 357.98 122.141C358.113 123.223 358.782 123.907 358.815 125.056C358.882 127.434 357.596 128.779 356.159 130.339C355.02 131.578 354.366 133.272 352.995 134.335C352.127 135.009 351.017 135.23 350.101 135.833C346.695 138.077 346.629 143.47 344.252 146.399C343.55 147.265 337.569 152.558 336.051 151.002C335.268 150.198 336.795 149.878 337.004 149.17C337.274 148.251 336.942 147.892 336.881 147.074C336.729 145.155 335.581 143.657 335.377 141.848C335.258 140.762 336.264 139.714 335.439 138.742C334.964 138.187 334.125 138.589 333.522 138.307C331.269 137.249 331.625 135.66 332.014 133.473C332.555 130.435 330.344 127.109 333.518 125.065H333.513Z",
    fill: "url(#paint9_radial_10512_4421)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M368.094 113.778C367.093 114.184 366.187 113.567 365.229 114.05C364.512 114.409 364.048 115.323 363.421 115.338C363.085 115.582 362.653 115.668 362.207 115.63C361.405 113.907 363.459 112.993 364.607 112.141C365.428 111.528 365.921 111.796 366.415 110.634C366.832 109.643 366.732 108.341 366.69 107.265C366.581 104.652 364.19 103.427 361.714 103.881C360.68 104.073 360.229 104.805 359.29 103.824C358.436 102.929 358.479 101.465 357.511 100.469C355.556 98.4642 354.494 96.1911 351.947 94.8991C350.699 94.2674 349.394 93.6022 348.346 92.7696C346.624 91.4057 347.938 91.042 347.26 89.458C346.757 88.276 345.552 88.5871 344.499 88.3239C343.498 88.075 341.757 87.5199 341.188 86.5868C340.41 85.3043 341.159 84.6104 341.629 83.5097C341.857 82.9738 341.454 82.4665 342.037 82.0837C343.009 81.4472 343.133 82.6866 343.835 82.6914C344.508 82.6962 344.755 82.0741 345.31 82.0789C346.373 82.0885 346.449 82.8158 347.094 83.4858C348.46 84.9023 350.405 85.6058 352.397 85.3808C354.152 85.1846 355.258 84.6343 353.479 83.2896C352.615 82.6388 352.264 82.9881 352.065 81.763C352.018 81.4807 352.454 80.9304 352.255 80.3848C352.644 80.1982 353.085 80.1264 353.559 80.1456C363.251 87.4769 369.579 99.0815 369.792 112.194C369.308 112.931 368.744 113.514 368.099 113.778H368.094Z",
    fill: "url(#paint10_radial_10512_4421)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M297.252 93.9136C297.926 94.2725 298.296 95.4067 298.889 95.5885C299.316 95.7177 301.83 94.8181 302.485 94.6362C303.144 94.4544 304.325 94.2247 304.643 93.6217C305.274 92.4253 303.931 91.497 306.047 91.4922C306.806 91.4922 308.001 91.8655 308.884 91.9707C309.875 92.0904 310.71 92.3871 311.588 92.7555C312.342 93.0714 312.921 93.4781 313.675 93.4303C313.708 93.5786 313.76 93.7174 313.988 93.6983C315.226 93.8083 316.668 95.3636 317.18 96.359C317.612 97.1916 317.569 97.8999 318.153 98.7278C318.608 99.3738 319.211 99.8523 319.704 100.446C321.137 102.173 321.511 103.676 321.293 105.896C321.132 107.543 322.057 109.452 321.53 110.878C321.137 111.945 320.074 112.309 319.453 113.161C318.921 113.893 318.869 114.888 318.248 115.577C316.867 117.113 314.932 116.582 313.2 116.754C312.551 116.821 311.863 117.319 311.108 117.061C310.302 116.783 309.975 115.706 308.945 115.515C308.039 115.348 307.722 115.927 307.029 116.013C306.298 116.099 305.625 115.726 304.913 115.817C302.883 116.07 303.893 118.855 302.836 120.368C302.352 121.061 301.588 121.492 301.166 122.339C300.578 123.521 300.701 124.483 300.431 125.708C300.265 126.474 299.207 127.306 299.216 127.895C299.23 128.718 300.117 128.728 300.393 129.383C300.81 130.369 300.412 131.881 299.999 132.795C299.425 134.059 299.216 134.757 298.917 136.121C298.789 136.71 298.433 138.155 297.817 138.662C292.148 131.628 288.752 122.66 288.752 112.888C288.752 107.021 289.98 101.436 292.186 96.3925C293.519 94.4879 295.236 92.8369 297.262 93.9184L297.252 93.9136Z",
    fill: "url(#paint11_radial_10512_4421)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M324.5 73.1152C326.682 72.4308 328.48 73.1008 330.662 73.5506C331.653 73.7564 335.458 73.5267 335.591 74.9528C336.174 75.594 334.784 75.4361 334.424 75.3404C333.845 75.1873 333.394 75.0054 332.806 75.2782C332.768 76.0199 333.076 76.8669 333.408 77.4651C333.888 78.3265 334.661 78.6376 334.405 79.8578C334.22 80.724 333.029 81.0494 332.151 80.7623C331.445 80.5326 330.871 79.6138 330.301 79.1257C329.642 78.561 328.949 78.2499 328.11 78.0872C327.009 77.8719 325.885 77.714 324.799 77.4029C323.452 77.0201 322.133 76.13 320.733 76.0438C320.103 74.7661 323.746 73.3496 324.5 73.1104V73.1152Z",
    fill: "url(#paint12_radial_10512_4421)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M316.896 90.6781C317.057 91.8122 316.72 92.4535 315.458 92.6162C314.486 92.7406 313.419 92.1663 312.584 91.6399C311.901 91.2093 311.773 90.9221 311.497 90.2617C311.161 89.4482 310.549 89.5248 310.032 88.9505C309.51 88.3667 309.685 87.8355 308.694 87.4623C307.883 87.156 307.133 87.2373 306.36 87.5819C304.956 88.2136 302.352 89.654 300.881 88.405C300.089 87.735 300.407 86.7684 300.929 85.974C302.039 84.2847 303.784 82.2988 305.796 81.7676C306.934 81.4661 308.319 81.5475 309.382 82.0499C310.259 82.4663 310.544 83.4616 311.412 83.921C312.399 84.4426 313.395 84.1172 312.721 85.5433C312.531 85.9453 312.237 86.1319 312.266 86.7014C312.285 87.1368 312.309 87.5005 312.731 87.7207C313.879 88.3141 315.454 87.3043 316.611 88.07V88.0796C317.09 88.3236 317.043 88.7878 316.995 89.2424C316.934 89.8119 316.81 90.0655 316.896 90.6781Z",
    fill: "url(#paint13_radial_10512_4421)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M329.267 72C337.953 72 345.998 74.7564 352.592 79.4461C347.649 76.8285 342.023 75.345 336.055 75.345C316.393 75.345 300.454 91.4241 300.454 111.26C300.454 131.095 316.393 147.174 336.055 147.174C347.99 147.174 358.55 141.25 365.011 132.162C358.18 145.016 344.736 153.764 329.267 153.764C306.887 153.764 288.742 135.46 288.742 112.882C288.742 90.3043 306.887 72 329.267 72Z",
    fill: "#26426A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M328.646 159.41V159.511C328.855 159.511 329.059 159.511 329.267 159.511C330.173 159.511 331.07 159.482 331.962 159.429V164.454C331.07 164.502 330.169 164.531 329.267 164.531C329.059 164.531 328.855 164.531 328.646 164.531V181.997H326.573V164.464V159.439V159.415H328.646V159.41Z",
    fill: "#9E4435"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M295.478 189.731H363.056V185.549C340.254 178.859 317.731 178.859 295.478 185.549V189.731Z",
    fill: "url(#paint14_linear_10512_4421)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M329.267 162.549C356.415 162.549 378.502 140.268 378.502 112.886C378.502 99.6019 373.369 87.1167 364.048 77.7324L360.537 81.288C368.915 89.7247 373.53 100.947 373.53 112.886C373.53 137.503 353.678 157.534 329.272 157.534C317.437 157.534 306.313 152.878 297.95 144.427L294.425 147.973C303.728 157.376 316.104 162.554 329.267 162.554V162.549Z",
    fill: "url(#paint15_linear_10512_4421)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M329.006 180.533C324.571 181.883 322.114 185.553 322.114 185.553H363.056V189.736H295.478V185.553C306.583 182.213 317.764 180.538 329.006 180.533Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M373.734 111.213C373.734 113.385 373.577 115.525 373.279 117.616C373.44 116.06 373.525 114.481 373.525 112.883C373.525 100.939 368.914 89.7167 360.532 81.2847L361.457 80.3516C369.379 88.6974 373.734 99.6129 373.734 111.213Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M295.364 147.022C304.581 155.966 316.654 160.876 329.476 160.876C354.252 160.876 374.816 142.313 378.217 118.252C375.556 143.122 354.617 162.546 329.272 162.546C316.104 162.546 303.732 157.368 294.43 147.965L295.369 147.017L295.364 147.022Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M334.959 82.1645C320.871 93.994 351.937 110.245 359.56 104.168C371.386 94.7454 347.25 71.8471 334.959 82.1645Z",
    fill: "#FFF7E6"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M359.574 110.418C348.522 109.657 352.416 125.014 357.719 125.224C365.95 125.55 368.236 111.016 359.574 110.418Z",
    fill: "#FFF7E6"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M186 194.952L277.13 194.685L231.434 148.85L186 194.948V194.952ZM255.988 186.195L207.09 186.339L231.468 161.603L255.988 186.195Z",
    fill: "url(#paint16_linear_10512_4421)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M227.384 156.013L227.583 155.812L226.07 154.295L225.87 154.491L227.384 156.013Z",
    fill: "#463332"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M226.155 157.263L226.349 157.062L224.836 155.545L224.642 155.741L226.155 157.263Z",
    fill: "#463332"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M223.347 160.105L223.542 159.908L222.028 158.387L221.834 158.588L223.347 160.105Z",
    fill: "#463332"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M222.113 161.353L222.312 161.157L220.799 159.635L220.6 159.836L222.113 161.353Z",
    fill: "#463332"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M219.305 164.196L219.504 163.999L217.991 162.482L217.797 162.679L219.305 164.196Z",
    fill: "#463332"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M218.076 165.446L218.271 165.249L216.758 163.732L216.563 163.929L218.076 165.446Z",
    fill: "#463332"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M215.268 168.292L215.463 168.091L213.954 166.574L213.755 166.77L215.268 168.292Z",
    fill: "#463332"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M214.035 169.542L214.234 169.341L212.721 167.824L212.522 168.02L214.035 169.542Z",
    fill: "#463332"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M211.231 172.384L211.426 172.188L209.912 170.666L209.718 170.867L211.231 172.384Z",
    fill: "#463332"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M209.998 173.632L210.192 173.431L208.679 171.914L208.485 172.11L209.998 173.632Z",
    fill: "#463332"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M207.19 176.476L207.389 176.28L205.876 174.758L205.677 174.959L207.19 176.476Z",
    fill: "#463332"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M205.957 177.724L206.156 177.528L204.643 176.006L204.443 176.207L205.957 177.724Z",
    fill: "#463332"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M203.12 180.605L203.314 180.404L201.801 178.887L201.606 179.083L203.12 180.605Z",
    fill: "#463332"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M201.887 181.855L202.081 181.654L200.568 180.137L200.373 180.333L201.887 181.855Z",
    fill: "#463332"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M199.064 184.711L199.258 184.515L197.745 182.998L197.55 183.194L199.064 184.711Z",
    fill: "#463332"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M197.831 185.96L198.026 185.764L196.512 184.242L196.318 184.443L197.831 185.96Z",
    fill: "#463332"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M194.942 188.888L195.137 188.692L193.623 187.17L193.429 187.371L194.942 188.888Z",
    fill: "#463332"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M193.709 190.138L193.903 189.942L192.395 188.42L192.195 188.621L193.709 190.138Z",
    fill: "#463332"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M230.035 155.893L230.301 155.625L227.516 152.83L227.25 153.098L230.035 155.893Z",
    fill: "#463332"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M225.979 160.003L226.245 159.735L223.46 156.936L223.195 157.208L225.979 160.003Z",
    fill: "#463332"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M221.924 164.114L222.189 163.846L219.405 161.047L219.139 161.32L221.924 164.114Z",
    fill: "#463332"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M217.868 168.226L218.134 167.958L215.349 165.158L215.083 165.431L217.868 168.226Z",
    fill: "#463332"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M213.812 172.335L214.078 172.067L211.293 169.268L211.027 169.536L213.812 172.335Z",
    fill: "#463332"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M209.756 176.446L210.022 176.178L207.237 173.379L206.971 173.647L209.756 176.446Z",
    fill: "#463332"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M205.7 180.558L205.966 180.285L203.177 177.49L202.911 177.758L205.7 180.558Z",
    fill: "#463332"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M201.644 184.667L201.91 184.394L199.121 181.6L198.855 181.868L201.644 184.667Z",
    fill: "#463332"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M197.589 188.774L197.854 188.506L195.065 185.711L194.8 185.979L197.589 188.774Z",
    fill: "#463332"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M193.528 192.885L193.794 192.617L191.009 189.822L190.748 190.09L193.528 192.885Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M226.297 194.838C226.297 194.46 226.297 193.269 226.287 191.211H228.598L228.583 186.277L255.987 186.196L235.153 165.298C235.092 165.063 235.011 164.838 235.006 164.585L234.973 152.841C234.973 152.712 235.03 152.607 235.044 152.482L277.125 194.69L226.292 194.838H226.297Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M256.5 185.698L255.494 185.703L231.477 161.613L231.98 161.105L256.5 185.698Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M231.43 148.855L231.79 149.214L187.2 194.456L276.632 194.193L277.125 194.69L186 194.954L231.43 148.855Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M207.044 187.04L234.177 186.959L234.175 186.303L207.042 186.385L207.044 187.04Z",
    fill: "#FFF7E6"
  }))), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M372.889 192.634L374.069 192.324L373.25 189.147L372.07 189.457L372.889 192.634Z",
    fill: "url(#paint17_linear_10512_4421)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M372.885 192.64L373.486 192.482L372.667 189.305L372.066 189.463L372.885 192.64Z",
    fill: "#463332"
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M369.574 194.58L377.78 194.556C378.435 194.556 378.966 194.015 378.966 193.355C378.966 192.694 378.43 192.158 377.775 192.158L369.569 192.182C368.914 192.182 368.383 192.723 368.383 193.383C368.383 194.044 368.919 194.58 369.574 194.58Z",
    fill: "url(#paint18_linear_10512_4421)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M372.729 189.564C373.853 189.267 374.526 188.109 374.232 186.975L373.782 185.223C373.488 184.089 372.34 183.41 371.215 183.706C370.091 184.003 369.418 185.161 369.712 186.295L370.162 188.047C370.456 189.181 371.604 189.86 372.729 189.564Z",
    fill: "url(#paint19_linear_10512_4421)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M371.22 183.706C371.486 183.634 371.751 183.629 372.012 183.663C372.306 183.84 372.629 183.969 372.966 184.065C373.35 184.342 373.658 184.73 373.786 185.227L374.199 186.821C373.711 187.352 373.108 187.788 372.363 187.984C372.017 188.075 371.671 188.099 371.325 188.094C371.794 188.864 372.691 189.29 373.601 189.061C373.355 189.285 373.075 189.477 372.729 189.568C371.604 189.865 370.456 189.18 370.162 188.051L369.712 186.299C369.418 185.165 370.091 184.007 371.215 183.71L371.22 183.706Z",
    fill: "#463332"
  }))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M372.131 187.252C374.223 186.702 375.475 184.549 374.93 182.443L353.65 99.8848L346.079 101.871L367.359 184.429C367.904 186.539 370.039 187.803 372.126 187.252H372.131Z",
    fill: "url(#paint20_linear_10512_4421)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M346.084 101.871L353.654 99.8848L354.461 103.014C353.621 104.469 352.383 105.642 350.903 106.407L370.015 180.548C370.561 182.658 372.695 183.922 374.783 183.371C374.877 183.348 374.963 183.3 375.058 183.271C375.134 185.089 373.952 186.779 372.136 187.252C370.044 187.803 367.909 186.535 367.368 184.429L347.502 107.364L346.088 101.871H346.084Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M369.564 192.185L372.842 192.176C372.187 192.176 371.656 192.717 371.656 193.377C371.656 194.037 372.192 194.573 372.847 194.568L369.569 194.578C368.914 194.578 368.378 194.047 368.378 193.386C368.378 192.726 368.905 192.185 369.56 192.185H369.564Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M369.569 193.766L377.776 193.742C378.288 193.742 378.715 193.407 378.881 192.947C378.928 193.076 378.961 193.21 378.961 193.354C378.961 194.014 378.435 194.555 377.776 194.555L369.569 194.579C368.914 194.579 368.378 194.048 368.378 193.388C368.378 193.244 368.412 193.11 368.459 192.981C368.625 193.44 369.052 193.77 369.569 193.77V193.766Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M378.16 192.698C378.307 192.243 375.522 192.353 375.423 192.592C375.271 192.966 378.032 193.095 378.16 192.698Z",
    fill: "#FFF7E6"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M375.072 192.697C375.124 192.367 374.156 192.449 374.123 192.621C374.071 192.889 375.029 192.985 375.072 192.697Z",
    fill: "#FFF7E6"
  }))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M318.476 191.153C320.549 191.751 322.707 190.536 323.3 188.445L324.215 185.215C324.808 183.123 323.604 180.946 321.531 180.348C319.458 179.75 317.299 180.965 316.706 183.056L315.791 186.287C315.198 188.378 316.403 190.555 318.476 191.153Z",
    fill: "url(#paint21_linear_10512_4421)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M317.683 193.948C319.206 194.388 320.795 193.493 321.232 191.957L321.905 189.578C322.342 188.042 321.455 186.439 319.932 185.999C318.409 185.559 316.82 186.454 316.384 187.99L315.71 190.368C315.274 191.904 316.161 193.507 317.683 193.948Z",
    fill: "url(#paint22_linear_10512_4421)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M319.301 188.229C321.378 188.827 323.541 187.612 324.134 185.516L347.762 101.972L340.244 99.8086L316.616 183.353C316.023 185.449 317.228 187.631 319.305 188.229H319.301Z",
    fill: "url(#paint23_linear_10512_4421)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M316.611 183.353L339.371 102.881L340.239 99.8086L347.758 101.972L346.24 107.341C344.717 107.216 343.313 106.695 342.118 105.881L320.719 181.549C320.126 183.645 321.331 185.827 323.409 186.425C323.504 186.454 323.603 186.458 323.698 186.478C322.806 187.951 321.028 188.722 319.301 188.224C317.223 187.626 316.023 185.444 316.616 183.348L316.611 183.353Z",
    fill: "#9E4435"
  }))), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M344.366 92.826L349.503 92.8117L349.47 81.2931C349.47 79.8623 348.313 78.7042 346.894 78.709C345.476 78.709 344.328 79.8766 344.333 81.3075L344.366 92.826Z",
    fill: "url(#paint24_linear_10512_4421)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M346.895 78.709C347.046 78.709 347.179 78.7712 347.326 78.7951C346.52 79.2354 345.955 80.068 345.96 81.0538L345.974 85.8967C346.287 85.8536 346.596 85.8106 346.918 85.8058C347.82 85.8058 348.669 85.9781 349.489 86.2317L349.508 92.5628V92.8117L344.371 92.826L344.352 86.246L344.338 81.3075C344.338 79.8766 345.481 78.7138 346.899 78.709H346.895Z",
    fill: "#463332"
  }))), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M353.099 102.556C356.501 99.1253 356.501 93.5622 353.099 90.1311C349.698 86.6999 344.184 86.6999 340.783 90.1311C337.381 93.5622 337.381 99.1253 340.783 102.556C344.184 105.988 349.698 105.988 353.099 102.556Z",
    fill: "url(#paint25_linear_10512_4421)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M342.255 96.0993C342.265 98.8557 344.504 101.081 347.265 101.076C350.025 101.067 352.255 98.827 352.245 96.0706C352.236 93.3142 349.997 91.089 347.236 91.0938C344.475 91.1033 342.246 93.3429 342.255 96.0993Z",
    fill: "#9E4435"
  }))), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M350.255 99.687C352.085 97.8406 352.085 94.847 350.255 93.0005C348.425 91.1541 345.457 91.1541 343.627 93.0005C341.797 94.8469 341.797 97.8406 343.627 99.687C345.457 101.533 348.425 101.533 350.255 99.687Z",
    fill: "url(#paint26_linear_10512_4421)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M345.486 87.7051C342.047 88.6813 339.513 91.8397 339.523 95.6202C339.537 100.166 343.199 103.837 347.706 103.827C351.453 103.818 354.57 101.243 355.518 97.7688C354.845 101.932 351.292 105.119 346.975 105.134C342.165 105.148 338.252 101.224 338.237 96.3715C338.223 92.012 341.368 88.4133 345.49 87.7099L345.486 87.7051Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M346.781 93.0265C345.026 94.51 348.911 96.5247 349.859 95.7638C351.33 94.5818 348.313 91.7344 346.781 93.0265Z",
    fill: "#FFF7E6"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M349.859 96.5442C348.479 96.4532 348.972 98.3674 349.632 98.3913C350.661 98.4296 350.941 96.6159 349.859 96.5442Z",
    fill: "#FFF7E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M347.212 79.3406C346.003 80.0202 348.038 81.5994 348.688 81.2548C349.698 80.7189 348.27 78.7473 347.212 79.3406Z",
    fill: "#FFF7E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M346.928 91.6152C346.985 91.6152 347.037 91.6296 347.094 91.6296C344.807 91.7253 342.986 93.6155 342.991 95.9461C342.995 98.334 344.921 100.258 347.284 100.253C349.651 100.248 351.558 98.3053 351.553 95.9221C351.553 95.6829 351.52 95.4484 351.482 95.2187C351.567 95.5776 351.629 95.9461 351.629 96.3289C351.638 98.9417 349.542 101.062 346.956 101.071C344.366 101.081 342.265 98.9657 342.255 96.3576C342.246 93.7495 344.342 91.6248 346.928 91.6152Z",
    fill: "#463332"
  }))), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M292.618 151.964L335.676 151.84L355.186 194.636L312.954 194.76L292.722 153.424C292.49 152.955 292.475 152.438 292.613 151.969L292.618 151.964Z",
    fill: "url(#paint27_linear_10512_4421)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M292.618 151.964L335.676 151.84L355.186 194.636L312.954 194.76L292.722 153.424C292.49 152.955 292.475 152.438 292.613 151.969L292.618 151.964Z",
    fill: "#60578F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M294.055 156.132L292.727 153.419C292.495 152.95 292.48 152.433 292.618 151.964L335.676 151.84L337.573 156.003L294.055 156.132Z",
    fill: "#60578F"
  }))), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M335.676 151.84L292.618 151.965C292.77 151.453 293.111 151.003 293.624 150.749L300.986 147.083C301.099 147.026 301.583 146.892 301.702 146.892C301.745 146.892 301.783 146.892 301.825 146.892L344.281 146.768L344.305 154.735L337.009 154.754L335.681 151.84H335.676Z",
    fill: "url(#paint28_linear_10512_4421)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M335.676 151.84L292.618 151.965C292.77 151.453 293.111 151.003 293.624 150.749L300.986 147.083C301.427 146.863 301.697 146.892 301.825 146.892L344.281 146.768L335.676 151.84Z",
    fill: "#60578F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M326.895 150.653L334.257 146.987C334.699 146.767 334.969 146.796 335.097 146.796L339.134 146.786C339.01 146.786 338.735 146.758 338.294 146.978L330.932 150.643C330.42 150.897 330.078 151.352 329.926 151.859L325.89 151.869C326.041 151.356 326.383 150.907 326.895 150.653Z",
    fill: "#60578F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M297.167 150.739L304.529 147.073C304.97 146.853 305.241 146.882 305.369 146.882L309.406 146.872C309.282 146.872 309.007 146.844 308.566 147.064L301.204 150.729C300.692 150.983 300.35 151.438 300.198 151.945L296.161 151.954C296.313 151.442 296.655 150.993 297.167 150.739Z",
    fill: "#60578F"
  }))), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M356.581 192.401L363.488 188.96L364.095 190.195C365.418 189.535 366.097 189.2 366.097 189.2L345.865 147.863C345.381 146.877 344.195 146.47 343.218 146.959L335.856 150.624C334.879 151.112 334.476 152.309 334.96 153.294L355.191 194.631C355.191 194.631 355.874 194.291 357.188 193.636L356.581 192.401Z",
    fill: "url(#paint29_linear_10512_4421)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M345.051 151.26L363.504 188.959L356.597 192.4L338.144 154.701C337.837 154.074 338.091 153.318 338.712 153.009L343.374 150.686C343.995 150.377 344.744 150.633 345.051 151.26Z",
    fill: "#CEB6AA"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M345.018 151.206L338.11 154.646L356.582 192.384L363.49 188.943L345.018 151.206Z",
    fill: "#CEB6AA"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M343.28 150.557L338.65 152.863C338.019 153.174 337.763 153.945 338.076 154.576L356.586 192.396L363.493 188.955L344.983 151.136C344.675 150.499 343.911 150.241 343.285 150.557H343.28Z",
    fill: "#FFE6D6"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M344.077 153.834C343.764 153.198 343.005 152.94 342.374 153.251L338.394 155.232L338.071 154.571C337.763 153.935 338.019 153.169 338.645 152.858L343.275 150.552C343.906 150.241 344.665 150.499 344.973 151.131L363.483 188.95L361.695 189.84L344.072 153.83L344.077 153.834Z",
    fill: "#CEB6AA"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M340.984 153.826C340.984 153.826 341.942 155.889 343.384 158.98C344.859 162.057 346.828 166.153 348.796 170.255C350.827 174.322 352.857 178.395 354.38 181.443C355.94 184.477 356.979 186.496 356.979 186.496C356.979 186.496 356.021 184.434 354.579 181.342C353.104 178.265 351.135 174.169 349.166 170.068C347.136 166 345.106 161.933 343.583 158.88C342.022 155.846 340.984 153.826 340.984 153.826Z",
    fill: "#CEB6AA"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M355.561 179.453C355.561 179.453 355.803 180.08 356.192 181.004C356.581 181.927 357.15 183.138 357.724 184.344C358.326 185.54 358.929 186.732 359.422 187.608C359.911 188.483 360.262 189.057 360.262 189.057C360.262 189.057 360.024 188.431 359.631 187.507C359.242 186.583 358.673 185.373 358.094 184.167C357.491 182.97 356.889 181.779 356.396 180.908C355.907 180.032 355.556 179.458 355.556 179.458L355.561 179.453Z",
    fill: "#CEB6AA"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M341.335 158.186C341.335 158.186 342.056 159.76 343.133 162.124C344.224 164.483 345.728 167.598 347.236 170.719C348.773 173.824 350.31 176.925 351.501 179.232C352.705 181.534 353.507 183.07 353.507 183.07C353.507 183.07 352.786 181.495 351.709 179.131C350.618 176.772 349.114 173.657 347.606 170.537C346.069 167.431 344.532 164.33 343.337 162.023C342.132 159.722 341.33 158.186 341.33 158.186H341.335Z",
    fill: "#CEB6AA"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M329.348 163.948L329.315 152.927H331.255C331.25 150.812 331.246 149.73 331.246 149.73L242.098 149.989C240.552 149.989 239.3 151.262 239.304 152.827L239.338 164.57C239.338 166.13 240.599 167.394 242.151 167.389L331.298 167.13C331.298 167.13 331.298 166.044 331.288 163.943H329.348V163.948Z",
    fill: "url(#paint30_linear_10512_4421)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M329.348 163.948L245.902 164.192C244.921 164.192 244.124 163.397 244.124 162.407L244.105 154.97C244.105 153.98 244.892 153.176 245.874 153.176L329.319 152.932L329.353 163.952L329.348 163.948Z",
    fill: "#CEB6AA"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M329.324 152.917L284.697 153.051L284.729 164.072L329.357 163.938L329.324 152.917Z",
    fill: "#CEB6AA"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M329.324 152.917L284.697 153.051L284.729 164.072L329.357 163.938L329.324 152.917Z",
    fill: "#FFE6D6"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M286.935 159.866C286.935 159.866 289.136 159.928 292.437 160.014C295.739 160.086 300.141 160.101 304.543 160.11C308.945 160.077 313.347 160.038 316.649 159.947C319.951 159.837 322.152 159.766 322.152 159.766C322.152 159.766 319.951 159.703 316.649 159.617C313.347 159.545 308.945 159.531 304.543 159.521C300.141 159.555 295.739 159.598 292.437 159.684C289.136 159.794 286.935 159.866 286.935 159.866Z",
    fill: "#CEB6AA"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M312.37 157.181C312.37 157.181 313.309 157.262 314.723 157.339C316.137 157.416 318.015 157.439 319.898 157.454C321.782 157.43 323.66 157.396 325.074 157.31C326.487 157.234 327.427 157.138 327.427 157.138C327.427 157.138 326.487 157.047 325.074 156.98C323.66 156.904 321.782 156.88 319.898 156.865C318.015 156.889 316.137 156.927 314.723 157.009C313.314 157.095 312.37 157.181 312.37 157.181Z",
    fill: "#CEB6AA"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M292.656 162.134C292.656 162.134 294.093 162.215 296.251 162.287C298.41 162.364 301.284 162.383 304.159 162.392C307.034 162.364 309.908 162.325 312.062 162.239C314.215 162.163 315.653 162.062 315.653 162.062C315.653 162.062 314.215 161.971 312.057 161.904C309.899 161.828 307.024 161.808 304.149 161.799C301.275 161.828 298.4 161.866 296.247 161.952C294.093 162.038 292.656 162.129 292.656 162.129V162.134Z",
    fill: "#CEB6AA"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M329.32 152.921L284.692 153.055L284.699 155.557L329.327 155.424L329.32 152.921Z",
    fill: "#CEB6AA"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M242.098 149.993L282.813 149.873L282.865 167.273L242.151 167.393C240.604 167.393 239.342 166.134 239.338 164.574L239.304 152.83C239.304 151.27 240.552 149.997 242.098 149.993Z",
    fill: "url(#paint31_linear_10512_4421)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M242.098 149.993L282.457 149.873C280.911 149.873 279.658 151.146 279.663 152.711L279.696 164.454C279.696 166.014 280.958 167.278 282.509 167.273L242.151 167.393C240.604 167.393 239.342 166.134 239.338 164.574L239.304 152.83C239.304 151.27 240.552 149.997 242.098 149.993Z",
    fill: "#398191"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M270.152 164.483L270.119 152.74C270.119 151.18 271.366 149.907 272.913 149.902L275.669 149.893C274.122 149.893 272.87 151.166 272.875 152.73L272.908 164.474C272.908 166.034 274.17 167.297 275.721 167.292L272.965 167.302C271.418 167.302 270.157 166.043 270.152 164.483Z",
    fill: "#398191"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M243.868 164.561L243.834 152.818C243.834 151.258 245.082 149.985 246.628 149.98L249.384 149.971C247.838 149.971 246.586 151.244 246.59 152.808L246.624 164.552C246.624 166.112 247.886 167.375 249.437 167.371L246.681 167.38C245.134 167.38 243.872 166.122 243.868 164.561Z",
    fill: "#398191"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M279.697 164.072V164.455C279.701 166.015 280.958 167.279 282.51 167.274L242.151 167.393C240.604 167.393 239.342 166.135 239.338 164.575V164.192L279.697 164.072Z",
    fill: "#398191"
  }))), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M325.719 147.757L325.7 141H326.891C326.891 139.703 326.886 139.043 326.886 139.043L245.319 139.282C244.37 139.282 243.602 140.062 243.607 141.019L243.626 148.221C243.626 149.179 244.399 149.954 245.348 149.949L326.914 149.71C326.914 149.71 326.914 149.045 326.91 147.752H325.719V147.757Z",
    fill: "url(#paint32_linear_10512_4421)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M247.633 141.219L325.708 140.986L325.728 147.743L247.653 147.976C247.05 147.978 246.565 147.487 246.563 146.884L246.55 142.323C246.548 141.716 247.035 141.226 247.633 141.224L247.633 141.219Z",
    fill: "#CEB6AA"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M325.703 140.992L288.528 141.104L288.548 147.861L325.723 147.749L325.703 140.992Z",
    fill: "#CEB6AA"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M325.703 140.992L288.528 141.104L288.548 147.861L325.723 147.749L325.703 140.992Z",
    fill: "#FFE6D6"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M289.9 145.284C289.9 145.284 291.864 145.317 294.805 145.365C297.751 145.379 301.674 145.398 305.601 145.418C309.529 145.374 313.452 145.336 316.398 145.303C319.344 145.236 321.303 145.193 321.303 145.193C321.303 145.193 319.339 145.159 316.398 145.111C313.452 145.097 309.529 145.078 305.601 145.059C301.674 145.102 297.751 145.14 294.805 145.173C291.859 145.24 289.9 145.284 289.9 145.284Z",
    fill: "#CEB6AA"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M315.311 143.608C315.311 143.608 315.89 143.666 316.753 143.699C317.617 143.718 318.774 143.747 319.927 143.776C322.237 143.785 324.542 143.58 324.542 143.58C324.542 143.58 322.232 143.388 319.927 143.412C318.774 143.446 317.621 143.479 316.753 143.503C315.89 143.546 315.311 143.604 315.311 143.604V143.608Z",
    fill: "#CEB6AA"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M293.41 146.676C293.41 146.676 294.904 146.71 297.148 146.763C299.392 146.777 302.38 146.801 305.369 146.82C311.346 146.82 317.327 146.605 317.327 146.605C317.327 146.605 311.35 146.428 305.369 146.456C302.38 146.495 299.392 146.533 297.148 146.562C294.904 146.629 293.41 146.672 293.41 146.672V146.676Z",
    fill: "#CEB6AA"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M325.703 140.992L288.528 141.104L288.532 142.635L325.708 142.524L325.703 140.992Z",
    fill: "#CEB6AA"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M245.314 139.283L287.371 139.158L287.4 149.825L245.343 149.949C244.394 149.949 243.621 149.179 243.621 148.222L243.602 141.02C243.602 140.063 244.365 139.283 245.314 139.283Z",
    fill: "url(#paint33_linear_10512_4421)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M245.314 139.282L287.153 139.162C286.204 139.162 285.436 139.942 285.441 140.899L285.46 148.101C285.46 149.058 286.233 149.834 287.182 149.829L245.343 149.948C244.394 149.948 243.621 149.178 243.621 148.221L243.602 141.019C243.602 140.062 244.365 139.282 245.314 139.282Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M279.611 148.117L279.592 140.915C279.592 139.958 280.356 139.178 281.304 139.178H282.993C282.044 139.178 281.276 139.953 281.281 140.91L281.3 148.112C281.3 149.069 282.073 149.844 283.022 149.84H281.333C280.384 149.849 279.611 149.074 279.611 148.117Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M275.033 148.131L275.014 140.929C275.014 139.971 275.778 139.191 276.727 139.191H278.416C277.467 139.191 276.698 139.967 276.703 140.924L276.722 148.126C276.722 149.083 277.495 149.858 278.444 149.853H276.755C275.807 149.863 275.033 149.088 275.033 148.131Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M251.481 148.197L251.462 140.995C251.462 140.038 252.226 139.258 253.174 139.258H254.863C253.914 139.258 253.146 140.033 253.151 140.99L253.17 148.192C253.17 149.149 253.943 149.925 254.892 149.92H253.203C252.254 149.929 251.481 149.154 251.481 148.197Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M246.903 148.213L246.884 141.011C246.884 140.053 247.648 139.273 248.597 139.273H250.286C249.337 139.273 248.568 140.049 248.573 141.006L248.592 148.208C248.592 149.165 249.365 149.94 250.314 149.935H248.625C247.677 149.945 246.903 149.17 246.903 148.213Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M285.464 147.862V148.097C285.464 149.054 286.238 149.829 287.186 149.824L245.347 149.944C244.399 149.944 243.625 149.173 243.625 148.216V147.982L285.464 147.857V147.862Z",
    fill: "#9E4435"
  }))), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M232.929 191.191L232.872 170.963H230.561C230.552 168.456 230.552 167.168 230.552 167.168L336.762 166.857C338.607 166.853 340.106 168.355 340.111 170.217L340.173 191.306C340.177 193.168 338.688 194.68 336.843 194.685L230.633 194.996C230.633 194.996 230.633 193.699 230.623 191.196H232.933L232.929 191.191Z",
    fill: "url(#paint34_linear_10512_4421)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M335.167 190.895L235.75 191.193L235.691 170.965L335.107 170.667C336.274 170.664 337.226 171.618 337.229 172.795L337.276 188.754C337.28 189.932 336.334 190.892 335.167 190.895Z",
    fill: "#A0335D"
  }))), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M232.929 191.192L332.346 190.9C333.513 190.9 334.457 189.938 334.457 188.761L334.409 172.801C334.409 171.624 333.456 170.672 332.289 170.672L232.872 170.964L232.929 191.192Z",
    fill: "#FFE6D6"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M230.557 170.973C230.548 168.456 230.548 167.174 230.548 167.174L284.744 167.016L284.824 194.843L230.628 195.001C230.628 195.001 230.628 193.704 230.619 191.201H232.929L232.872 170.968H230.562L230.557 170.973Z",
    fill: "#A0335D"
  }))), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M286.044 170.8L232.878 170.959L232.937 191.187L286.104 191.028L286.044 170.8Z",
    fill: "#CEB6AA"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M286.044 170.8L232.878 170.959L232.937 191.187L286.104 191.028L286.044 170.8Z",
    fill: "#CEB6AA"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M284.241 170.815L332.289 170.676C333.456 170.676 334.405 171.623 334.409 172.805L334.419 175.83C334.419 174.652 333.465 173.7 332.298 173.7L284.25 173.839L284.241 170.815Z",
    fill: "#CEB6AA"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M330.833 176.38C330.833 176.38 329.429 176.251 327.327 176.16C326.274 176.126 325.05 176.055 323.736 176.045C322.422 176.031 321.018 176.016 319.619 176.002C318.215 176.026 316.816 176.045 315.502 176.069C314.188 176.088 312.959 176.169 311.911 176.208C309.809 176.313 308.405 176.452 308.405 176.452C308.405 176.452 309.809 176.581 311.911 176.677C312.964 176.705 314.188 176.782 315.502 176.792C316.816 176.806 318.22 176.82 319.619 176.835C321.023 176.811 322.422 176.787 323.736 176.768C325.05 176.748 326.279 176.667 327.327 176.629C329.429 176.524 330.833 176.385 330.833 176.385V176.38Z",
    fill: "#CEB6AA"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M324.187 187.315C324.187 187.315 322.133 187.2 319.049 187.1C317.508 187.066 315.71 187.028 313.784 186.989C311.858 186.975 309.804 186.966 307.75 186.951C305.696 186.975 303.642 186.999 301.716 187.023C299.79 187.042 297.992 187.128 296.451 187.167C293.367 187.286 291.313 187.415 291.313 187.415C291.313 187.415 293.367 187.53 296.451 187.635C297.992 187.664 299.79 187.736 301.716 187.746C303.642 187.755 305.696 187.769 307.75 187.784C309.804 187.76 311.858 187.736 313.784 187.712C315.71 187.659 317.508 187.612 319.049 187.568C322.133 187.449 324.187 187.32 324.187 187.32V187.315Z",
    fill: "#CEB6AA"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M327.512 180.157C327.512 180.157 325.458 180.042 322.374 179.941C320.833 179.908 319.035 179.87 317.109 179.831C315.183 179.817 313.129 179.807 311.075 179.793C309.021 179.817 306.967 179.841 305.041 179.865C303.115 179.884 301.317 179.97 299.776 180.008C296.692 180.128 294.638 180.257 294.638 180.257C294.638 180.257 296.692 180.372 299.776 180.477C301.317 180.506 303.115 180.578 305.041 180.587C306.967 180.597 309.021 180.611 311.075 180.626C313.129 180.602 315.183 180.578 317.109 180.554C319.035 180.501 320.833 180.453 322.374 180.41C325.458 180.291 327.512 180.161 327.512 180.161V180.157Z",
    fill: "#CEB6AA"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M283.425 184.645C283.425 184.645 280.802 184.501 276.869 184.401C274.9 184.363 272.609 184.324 270.152 184.277C267.695 184.262 265.072 184.253 262.448 184.238C259.825 184.267 257.207 184.296 254.745 184.324C252.288 184.348 249.992 184.444 248.028 184.487C244.095 184.612 241.472 184.769 241.472 184.769C241.472 184.769 244.095 184.913 248.028 185.014C249.996 185.047 252.288 185.128 254.745 185.138C257.202 185.152 259.825 185.162 262.448 185.176C265.072 185.148 267.69 185.119 270.152 185.09C272.609 185.033 274.905 184.975 276.869 184.927C280.802 184.803 283.425 184.645 283.425 184.645Z",
    fill: "#B29B93"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M253.089 175.916C253.089 175.916 251.97 175.821 250.286 175.754C248.602 175.677 246.363 175.653 244.119 175.639C241.875 175.667 239.636 175.701 237.952 175.792C236.273 175.868 235.149 175.974 235.149 175.974C235.149 175.974 236.268 176.069 237.952 176.136C239.636 176.213 241.875 176.237 244.119 176.251C246.363 176.222 248.602 176.189 250.286 176.098C251.965 176.022 253.089 175.916 253.089 175.916Z",
    fill: "#B29B93"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M275.052 188.182C275.052 188.182 273.34 188.067 270.769 187.981C268.198 187.885 264.773 187.856 261.353 187.842C257.928 187.875 254.503 187.923 251.937 188.033C249.37 188.134 247.658 188.258 247.658 188.258C247.658 188.258 249.37 188.373 251.941 188.459C254.512 188.555 257.937 188.579 261.357 188.598C264.782 188.56 268.207 188.517 270.774 188.406C273.34 188.306 275.052 188.182 275.052 188.182Z",
    fill: "#B29B93"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M274.241 179.447C274.241 179.447 272.529 179.332 269.958 179.246C267.387 179.15 263.962 179.122 260.542 179.107C257.117 179.141 253.692 179.189 251.126 179.299C248.559 179.399 246.847 179.524 246.847 179.524C246.847 179.524 248.559 179.639 251.13 179.725C253.701 179.82 257.126 179.844 260.547 179.864C263.971 179.825 267.396 179.782 269.963 179.672C272.529 179.572 274.241 179.447 274.241 179.447Z",
    fill: "#B29B93"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M286.044 170.8L232.878 170.959L232.886 173.94L286.053 173.781L286.044 170.8Z",
    fill: "#B29B93"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M321.805 173.929C320.444 177.116 320.008 186.328 319.946 191.018H343.28C343.318 186.467 342.972 176.958 341.529 173.532C339.504 168.708 334.381 165.674 334.381 164.512C334.381 163.349 338.484 160.583 340.733 156.415C342.592 152.974 343.247 146.217 343.285 141.082H319.951C319.913 146.26 320.558 153.007 322.251 156.529C324.163 160.501 328.85 163.133 328.85 164.516C328.85 165.899 323.874 169.101 321.805 173.929ZM321.288 189.692C321.426 183.754 322.005 176.824 323.015 174.456C324.12 171.862 326.231 169.689 327.768 168.105C329.262 166.56 330.168 165.631 330.168 164.516C330.168 163.325 329.163 162.382 327.635 160.961C326.189 159.616 324.391 157.936 323.437 155.95C322.014 152.993 321.345 147.25 321.274 142.412H341.947C341.814 147.212 341.14 152.897 339.58 155.783C338.413 157.946 336.705 159.707 335.334 161.123C333.921 162.583 333.072 163.464 333.072 164.516C333.072 165.569 333.869 166.292 335.315 167.665C336.952 169.22 339.196 171.35 340.329 174.049C341.501 176.844 341.942 184.615 341.975 189.692H321.298H321.288Z",
    fill: "url(#paint35_linear_10512_4421)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M341.966 189.694C341.933 184.612 341.491 176.84 340.32 174.051C339.186 171.352 336.947 169.222 335.306 167.667C333.859 166.293 333.062 165.537 333.062 164.518C333.062 163.499 333.916 162.585 335.325 161.125C336.696 159.709 338.403 157.948 339.57 155.785C341.131 152.894 341.809 147.214 341.937 142.414H321.265C321.336 147.252 322.005 152.995 323.428 155.952C324.381 157.938 326.179 159.618 327.626 160.967C329.153 162.388 330.159 163.331 330.159 164.523C330.159 165.714 329.253 166.571 327.759 168.112C326.222 169.696 324.111 171.868 323.006 174.462C321.995 176.831 321.416 183.76 321.279 189.699H341.956L341.966 189.694Z",
    fill: "url(#paint36_linear_10512_4421)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M319.846 194.996H343.384C343.845 194.996 344.219 194.619 344.219 194.154V190.531C344.219 190.066 343.845 189.689 343.384 189.689H319.846C319.385 189.689 319.012 190.066 319.012 190.531V194.154C319.012 194.619 319.385 194.996 319.846 194.996Z",
    fill: "url(#paint37_linear_10512_4421)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M319.846 142.441H343.384C343.845 142.441 344.219 142.064 344.219 141.599V137.977C344.219 137.511 343.845 137.134 343.384 137.134H319.846C319.385 137.134 319.012 137.511 319.012 137.977V141.599C319.012 142.064 319.385 142.441 319.846 142.441Z",
    fill: "url(#paint38_linear_10512_4421)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M319.808 189.693H328.916V190.636C328.916 191.124 329.271 191.517 329.713 191.517H344.219V194.115C344.219 194.603 343.863 194.996 343.422 194.996H319.808C319.367 194.996 319.011 194.598 319.011 194.115V190.574C319.011 190.086 319.367 189.693 319.808 189.693Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M319.808 137.135H343.422C343.863 137.135 344.219 137.532 344.219 138.015V140.561H329.713C329.271 140.561 328.916 140.958 328.916 141.442V142.437H319.808C319.367 142.437 319.011 142.04 319.011 141.557V138.015C319.011 137.527 319.367 137.135 319.808 137.135Z",
    fill: "#463332"
  }))), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M318.438 194.996H344.793C345.139 194.996 345.419 194.713 345.419 194.364V192.914C345.419 192.566 345.139 192.283 344.793 192.283H318.438C318.092 192.283 317.811 192.566 317.811 192.914V194.364C317.811 194.713 318.092 194.996 318.438 194.996Z",
    fill: "url(#paint39_linear_10512_4421)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M318.409 192.287H328.314C327.982 192.287 327.716 192.584 327.716 192.948V194.34C327.716 194.704 327.982 195 328.314 195H318.409C318.077 195 317.811 194.704 317.811 194.34V192.948C317.811 192.584 318.077 192.287 318.409 192.287Z",
    fill: "#463332"
  }))), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M318.438 139.848H344.793C345.139 139.848 345.419 139.565 345.419 139.216V137.766C345.419 137.417 345.139 137.134 344.793 137.134H318.438C318.092 137.134 317.811 137.417 317.811 137.766V139.216C317.811 139.565 318.092 139.848 318.438 139.848Z",
    fill: "url(#paint40_linear_10512_4421)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M328.85 164.512C328.85 163.129 324.163 160.497 322.251 156.526C320.553 153.003 319.908 146.256 319.95 141.078H343.284C343.275 142.164 343.242 143.322 343.171 144.504H328.655C328.655 144.504 327.929 153.147 329.642 158.32C330.851 161.971 331.506 163.321 331.506 164.953C331.506 166.584 327.777 169.054 328.233 191.014H319.95C320.007 186.324 320.444 177.112 321.81 173.925C323.873 169.092 328.854 165.891 328.854 164.512H328.85Z",
    fill: "#398191"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M318.409 137.135H328.314C327.982 137.135 327.716 137.431 327.716 137.795V139.188C327.716 139.551 327.982 139.848 328.314 139.848H318.409C318.077 139.848 317.811 139.551 317.811 139.188V137.795C317.811 137.431 318.077 137.135 318.409 137.135Z",
    fill: "#463332"
  }))), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M327.631 160.961C326.184 159.616 324.386 157.937 323.433 155.951C322.84 154.716 322.38 152.974 322.038 151.031H341.069C340.704 152.917 340.216 154.592 339.575 155.783C338.408 157.946 336.701 159.707 335.33 161.124C333.916 162.583 332.763 163.684 332.265 164.43C331.634 165.373 331.445 165.287 330.899 164.43C330.434 163.698 329.153 162.387 327.631 160.966V160.961Z",
    fill: "url(#paint41_linear_10512_4421)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M322.247 152.079C322.176 151.735 322.104 151.39 322.038 151.031H341.069C340.998 151.39 340.922 151.739 340.842 152.079H322.247Z",
    fill: "#FFE675"
  }))), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M341.743 183.304C341.804 184.491 341.956 187.802 341.966 189.692H321.288C321.335 187.601 321.464 184.94 321.601 183.304C326.193 183.246 328.987 180.428 331.534 180.428C334.082 180.428 337.45 183.328 341.743 183.304Z",
    fill: "url(#paint42_linear_10512_4421)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M331.155 181.102C328.618 181.102 325.046 183.864 321.597 183.304C325.696 183.395 328.983 180.428 331.53 180.428C334.078 180.428 337.446 183.328 341.739 183.304C341.748 183.5 341.762 183.768 341.776 184.06C337.322 184.002 333.812 181.098 331.155 181.098V181.102Z",
    fill: "#FFE675"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M324.917 151.031C325.169 152.079 325.458 153.017 325.814 153.749C329.315 161.028 335.491 162.301 340.182 153.601C340.453 153.099 340.69 152.496 340.903 151.83C340.562 153.381 340.13 154.764 339.58 155.783C338.413 157.946 336.705 159.707 335.334 161.124C333.921 162.583 332.768 163.684 332.27 164.43C331.639 165.373 331.449 165.287 330.904 164.43C330.439 163.698 329.163 162.387 327.635 160.966C326.189 159.621 324.391 157.941 323.437 155.955C322.844 154.721 322.384 152.979 322.043 151.036H324.922L324.917 151.031Z",
    fill: "#AA2424"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M321.597 183.305C325.6 183.324 328.622 180.778 331.041 180.467C329.694 181.017 328.817 181.764 328.817 182.773C328.817 184.86 332.09 185.941 335.524 185.941C339.333 185.941 341.582 184.554 341.7 183.271C341.715 183.271 341.724 183.271 341.738 183.271C341.8 184.467 341.952 187.793 341.961 189.688H321.284C321.331 187.588 321.488 184.874 321.597 183.3V183.305Z",
    fill: "#AA2424"
  }))), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M331.615 167.828C331.956 167.828 332.232 167.55 332.232 167.206C332.232 166.863 331.956 166.584 331.615 166.584C331.275 166.584 330.998 166.863 330.998 167.206C330.998 167.55 331.275 167.828 331.615 167.828Z",
    fill: "#ED9C47"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M331.412 179.438C331.752 179.438 332.028 179.159 332.028 178.815C332.028 178.472 331.752 178.193 331.412 178.193C331.071 178.193 330.795 178.472 330.795 178.815C330.795 179.159 331.071 179.438 331.412 179.438Z",
    fill: "#ED9C47"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M330.519 171.604C330.519 171.848 330.714 172.045 330.956 172.045C331.198 172.045 331.392 171.848 331.392 171.604C331.392 171.36 331.198 171.164 330.956 171.164C330.714 171.164 330.519 171.36 330.519 171.604Z",
    fill: "#ED9C47"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M332.313 169.32C332.313 169.502 332.46 169.651 332.64 169.651C332.82 169.651 332.967 169.502 332.967 169.32C332.967 169.139 332.82 168.99 332.64 168.99C332.46 168.99 332.313 169.139 332.313 169.32Z",
    fill: "#ED9C47"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M331.326 177.155C331.507 177.155 331.653 177.007 331.653 176.824C331.653 176.642 331.507 176.494 331.326 176.494C331.145 176.494 330.998 176.642 330.998 176.824C330.998 177.007 331.145 177.155 331.326 177.155Z",
    fill: "#ED9C47"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M329.969 179.893C329.969 180.075 330.116 180.223 330.296 180.223C330.477 180.223 330.624 180.075 330.624 179.893C330.624 179.711 330.477 179.562 330.296 179.562C330.116 179.562 329.969 179.711 329.969 179.893Z",
    fill: "#ED9C47"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M332.602 180.098C332.602 180.28 332.749 180.428 332.929 180.428C333.109 180.428 333.257 180.28 333.257 180.098C333.257 179.916 333.109 179.768 332.929 179.768C332.749 179.768 332.602 179.916 332.602 180.098Z",
    fill: "#ED9C47"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M330.709 168.617C330.89 168.617 331.036 168.47 331.036 168.287C331.036 168.105 330.89 167.957 330.709 167.957C330.528 167.957 330.382 168.105 330.382 168.287C330.382 168.47 330.528 168.617 330.709 168.617Z",
    fill: "#ED9C47"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M331.245 172.805C331.245 172.987 331.393 173.135 331.573 173.135C331.753 173.135 331.9 172.987 331.9 172.805C331.9 172.623 331.753 172.475 331.573 172.475C331.393 172.475 331.245 172.623 331.245 172.805Z",
    fill: "#ED9C47"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M331.577 166.59C331.321 166.647 331.131 166.872 331.131 167.15C331.131 167.466 331.387 167.724 331.7 167.724C331.914 167.724 332.103 167.604 332.198 167.427C332.113 167.667 331.885 167.834 331.62 167.834C331.278 167.834 331.003 167.557 331.003 167.212C331.003 166.882 331.259 166.614 331.582 166.59H331.577Z",
    fill: "#AA2424"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M331.197 178.232C331.046 178.333 330.946 178.51 330.946 178.706C330.946 179.022 331.202 179.28 331.515 179.28C331.719 179.28 331.895 179.175 331.994 179.012C331.914 179.261 331.681 179.438 331.411 179.438C331.069 179.438 330.794 179.161 330.794 178.816C330.794 178.548 330.965 178.319 331.202 178.232H331.197Z",
    fill: "#AA2424"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M330.875 171.17C330.733 171.232 330.633 171.376 330.633 171.538C330.633 171.763 330.813 171.945 331.036 171.945C331.164 171.945 331.278 171.883 331.349 171.792C331.278 171.94 331.131 172.046 330.956 172.046C330.714 172.046 330.519 171.849 330.519 171.605C330.519 171.39 330.671 171.213 330.875 171.175V171.17Z",
    fill: "#AA2424"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M332.592 168.996C332.488 169.044 332.417 169.149 332.417 169.274C332.417 169.441 332.554 169.58 332.721 169.58C332.801 169.58 332.868 169.551 332.924 169.499C332.868 169.594 332.763 169.656 332.645 169.656C332.464 169.656 332.317 169.508 332.317 169.326C332.317 169.159 332.436 169.025 332.592 169.001V168.996Z",
    fill: "#AA2424"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M331.212 176.514C331.136 176.571 331.088 176.657 331.088 176.758C331.088 176.925 331.226 177.064 331.392 177.064C331.492 177.064 331.577 177.016 331.634 176.94C331.587 177.064 331.468 177.155 331.326 177.155C331.145 177.155 330.998 177.007 330.998 176.825C330.998 176.681 331.089 176.562 331.212 176.514Z",
    fill: "#AA2424"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M330.182 179.582C330.121 179.639 330.083 179.716 330.083 179.807C330.083 179.974 330.22 180.113 330.386 180.113C330.472 180.113 330.552 180.075 330.605 180.018C330.557 180.137 330.438 180.223 330.301 180.223C330.121 180.223 329.974 180.075 329.974 179.893C329.974 179.754 330.059 179.635 330.182 179.587V179.582Z",
    fill: "#AA2424"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M332.773 179.812C332.72 179.865 332.687 179.942 332.687 180.023C332.687 180.191 332.825 180.329 332.991 180.329C333.1 180.329 333.195 180.272 333.247 180.181C333.209 180.325 333.081 180.435 332.929 180.435C332.749 180.435 332.602 180.286 332.602 180.104C332.602 179.98 332.673 179.87 332.773 179.812Z",
    fill: "#AA2424"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M330.652 167.963C330.552 168.011 330.486 168.116 330.486 168.236C330.486 168.403 330.623 168.542 330.79 168.542C330.87 168.542 330.941 168.508 330.993 168.461C330.937 168.556 330.832 168.623 330.714 168.623C330.533 168.623 330.386 168.475 330.386 168.293C330.386 168.13 330.505 167.996 330.657 167.968L330.652 167.963Z",
    fill: "#AA2424"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M331.402 172.523C331.359 172.576 331.331 172.643 331.331 172.72C331.331 172.887 331.468 173.026 331.634 173.026C331.748 173.026 331.843 172.964 331.895 172.873C331.867 173.026 331.734 173.141 331.573 173.141C331.392 173.141 331.245 172.992 331.245 172.811C331.245 172.691 331.312 172.586 331.407 172.528L331.402 172.523Z",
    fill: "#AA2424"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6
  }, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M334.329 170.236C330.98 171.743 337.014 178.141 338.816 177.399C341.61 176.251 337.251 168.92 334.329 170.236Z",
    fill: "#FFF7E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M344.096 193.349C344.101 194.316 331.174 193.814 331.17 193.292C331.17 192.77 344.086 192.383 344.096 193.349Z",
    fill: "#FFF7E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M344.096 138.308C344.101 139.275 331.174 138.773 331.17 138.251C331.17 137.729 344.086 137.342 344.096 138.308Z",
    fill: "#FFF7E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6
  }, _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M338.669 145.604C335.017 145.288 335.5 153.897 337.355 154.5C339.831 155.309 341.639 145.863 338.669 145.604Z",
    fill: "#FFF7E6"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M336.653 155.653C334.893 154.528 332.474 159.587 333.351 160.079C334.708 160.845 338.033 156.538 336.653 155.653Z",
    fill: "#FFF7E6"
  }))), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M36.78 101.336C34.8013 101.336 33.1027 100.916 31.684 100.076C30.2653 99.2173 29.1733 98.032 28.408 96.52C27.6427 94.9893 27.26 93.2253 27.26 91.228C27.26 89.2307 27.6427 87.4667 28.408 85.936C29.1733 84.4053 30.2653 83.2107 31.684 82.352C33.1027 81.4933 34.8013 81.064 36.78 81.064C39.132 81.064 41.0547 81.652 42.548 82.828C44.06 83.9853 45.0027 85.6187 45.376 87.728H41.428C41.1853 86.664 40.6627 85.8333 39.86 85.236C39.076 84.62 38.0307 84.312 36.724 84.312C34.9133 84.312 33.4947 84.928 32.468 86.16C31.4413 87.392 30.928 89.0813 30.928 91.228C30.928 93.3747 31.4413 95.064 32.468 96.296C33.4947 97.5093 34.9133 98.116 36.724 98.116C38.0307 98.116 39.076 97.836 39.86 97.276C40.6627 96.6973 41.1853 95.904 41.428 94.896H45.376C45.0027 96.912 44.06 98.4893 42.548 99.628C41.0547 100.767 39.132 101.336 36.78 101.336ZM53.3645 101.336C51.6285 101.336 50.2845 100.795 49.3325 99.712C48.3992 98.6293 47.9325 97.0427 47.9325 94.952V87.112H51.4885V94.616C51.4885 95.8107 51.7312 96.7253 52.2165 97.36C52.7019 97.9947 53.4672 98.312 54.5125 98.312C55.5019 98.312 56.3139 97.9573 56.9485 97.248C57.6019 96.5387 57.9285 95.5493 57.9285 94.28V87.112H61.5125V101H58.3485L58.0685 98.648C57.6392 99.4693 57.0139 100.123 56.1925 100.608C55.3899 101.093 54.4472 101.336 53.3645 101.336ZM64.8837 101V87.112H68.0757L68.4117 89.716C68.9157 88.82 69.597 88.1107 70.4557 87.588C71.333 87.0467 72.3597 86.776 73.5357 86.776V90.556H72.5277C71.7437 90.556 71.0437 90.6773 70.4277 90.92C69.8117 91.1627 69.3264 91.5827 68.9717 92.18C68.6357 92.7773 68.4677 93.608 68.4677 94.672V101H64.8837ZM75.6773 101V87.112H78.8693L79.2053 89.716C79.7093 88.82 80.3906 88.1107 81.2493 87.588C82.1266 87.0467 83.1533 86.776 84.3293 86.776V90.556H83.3213C82.5373 90.556 81.8373 90.6773 81.2213 90.92C80.6053 91.1627 80.1199 91.5827 79.7653 92.18C79.4293 92.7773 79.2613 93.608 79.2613 94.672V101H75.6773ZM88.4028 84.956C87.7495 84.956 87.2081 84.76 86.7788 84.368C86.3681 83.976 86.1628 83.4813 86.1628 82.884C86.1628 82.2867 86.3681 81.8013 86.7788 81.428C87.2081 81.036 87.7495 80.84 88.4028 80.84C89.0561 80.84 89.5881 81.036 89.9988 81.428C90.4281 81.8013 90.6428 82.2867 90.6428 82.884C90.6428 83.4813 90.4281 83.976 89.9988 84.368C89.5881 84.76 89.0561 84.956 88.4028 84.956ZM86.6108 101V87.112H90.1948V101H86.6108ZM100.432 101.336C99.013 101.336 97.7623 101.028 96.6797 100.412C95.597 99.796 94.7383 98.9373 94.1037 97.836C93.4877 96.7347 93.1797 95.4747 93.1797 94.056C93.1797 92.6373 93.4877 91.3773 94.1037 90.276C94.7383 89.1747 95.597 88.316 96.6797 87.7C97.7623 87.084 99.013 86.776 100.432 86.776C102.205 86.776 103.698 87.2427 104.912 88.176C106.125 89.0907 106.9 90.36 107.236 91.984H103.456C103.269 91.312 102.896 90.7893 102.336 90.416C101.794 90.024 101.15 89.828 100.404 89.828C99.4143 89.828 98.5743 90.2013 97.8837 90.948C97.193 91.6947 96.8477 92.7307 96.8477 94.056C96.8477 95.3813 97.193 96.4173 97.8837 97.164C98.5743 97.9107 99.4143 98.284 100.404 98.284C101.15 98.284 101.794 98.0973 102.336 97.724C102.896 97.3507 103.269 96.8187 103.456 96.128H107.236C106.9 97.696 106.125 98.956 104.912 99.908C103.698 100.86 102.205 101.336 100.432 101.336ZM115.317 101.336C113.581 101.336 112.237 100.795 111.285 99.712C110.351 98.6293 109.885 97.0427 109.885 94.952V87.112H113.441V94.616C113.441 95.8107 113.683 96.7253 114.169 97.36C114.654 97.9947 115.419 98.312 116.465 98.312C117.454 98.312 118.266 97.9573 118.901 97.248C119.554 96.5387 119.881 95.5493 119.881 94.28V87.112H123.465V101H120.301L120.021 98.648C119.591 99.4693 118.966 100.123 118.145 100.608C117.342 101.093 116.399 101.336 115.317 101.336ZM126.836 101V80.84H130.42V101H126.836ZM138.982 101.336C137.246 101.336 135.902 100.795 134.95 99.712C134.017 98.6293 133.55 97.0427 133.55 94.952V87.112H137.106V94.616C137.106 95.8107 137.349 96.7253 137.834 97.36C138.319 97.9947 139.085 98.312 140.13 98.312C141.119 98.312 141.931 97.9573 142.566 97.248C143.219 96.5387 143.546 95.5493 143.546 94.28V87.112H147.13V101H143.966L143.686 98.648C143.257 99.4693 142.631 100.123 141.81 100.608C141.007 101.093 140.065 101.336 138.982 101.336ZM150.501 101V87.112H153.665L153.973 88.988C154.421 88.316 155.009 87.784 155.737 87.392C156.484 86.9813 157.342 86.776 158.313 86.776C160.46 86.776 161.981 87.6067 162.877 89.268C163.381 88.5027 164.053 87.896 164.893 87.448C165.752 87 166.685 86.776 167.693 86.776C169.504 86.776 170.894 87.3173 171.865 88.4C172.836 89.4827 173.321 91.0693 173.321 93.16V101H169.737V93.496C169.737 92.3013 169.504 91.3867 169.037 90.752C168.589 90.1173 167.889 89.8 166.937 89.8C165.966 89.8 165.182 90.1547 164.585 90.864C164.006 91.5733 163.717 92.5627 163.717 93.832V101H160.133V93.496C160.133 92.3013 159.9 91.3867 159.433 90.752C158.966 90.1173 158.248 89.8 157.277 89.8C156.325 89.8 155.55 90.1547 154.953 90.864C154.374 91.5733 154.085 92.5627 154.085 93.832V101H150.501ZM189.136 101.308C187.698 101.308 186.448 101.065 185.384 100.58C184.32 100.076 183.489 99.376 182.892 98.48C182.313 97.584 182.024 96.5387 182.024 95.344C182.024 94.0747 182.378 92.9267 183.088 91.9C183.797 90.8733 184.852 90.052 186.252 89.436C185.692 88.7827 185.29 88.1667 185.048 87.588C184.805 87.0093 184.684 86.3933 184.684 85.74C184.684 84.844 184.908 84.0507 185.356 83.36C185.804 82.6507 186.438 82.0907 187.26 81.68C188.1 81.2693 189.098 81.064 190.256 81.064C191.432 81.064 192.43 81.2787 193.252 81.708C194.073 82.1373 194.689 82.716 195.1 83.444C195.529 84.172 195.725 84.984 195.688 85.88H192.272C192.272 85.1893 192.066 84.676 191.656 84.34C191.264 83.9853 190.788 83.808 190.228 83.808C189.593 83.808 189.08 83.9853 188.688 84.34C188.314 84.6947 188.128 85.152 188.128 85.712C188.128 86.1787 188.277 86.6547 188.576 87.14C188.874 87.6253 189.313 88.1853 189.892 88.82L195.38 94.252C195.772 93.6173 196.182 92.88 196.612 92.04L197.228 90.808H200.896L199.916 92.712C199.169 94.224 198.422 95.5027 197.676 96.548L202.184 101H197.9L195.716 98.816C194.764 99.6933 193.746 100.328 192.664 100.72C191.6 101.112 190.424 101.308 189.136 101.308ZM185.496 95.12C185.496 96.0347 185.832 96.8093 186.504 97.444C187.194 98.06 188.109 98.368 189.248 98.368C190.872 98.368 192.281 97.7893 193.476 96.632L188.296 91.508C187.344 91.9187 186.634 92.432 186.168 93.048C185.72 93.664 185.496 94.3547 185.496 95.12ZM27.904 131V111.4H35.156C36.724 111.4 38.0213 111.661 39.048 112.184C40.0747 112.707 40.84 113.425 41.344 114.34C41.848 115.255 42.1 116.281 42.1 117.42C42.1 118.503 41.8573 119.501 41.372 120.416C40.8867 121.312 40.1307 122.04 39.104 122.6C38.0773 123.141 36.7613 123.412 35.156 123.412H31.488V131H27.904ZM31.488 120.5H34.932C36.1827 120.5 37.0787 120.229 37.62 119.688C38.18 119.128 38.46 118.372 38.46 117.42C38.46 116.449 38.18 115.693 37.62 115.152C37.0787 114.592 36.1827 114.312 34.932 114.312H31.488V120.5ZM50.5569 131.336C49.1569 131.336 47.9155 131.037 46.8329 130.44C45.7502 129.843 44.9009 129.003 44.2849 127.92C43.6689 126.837 43.3609 125.587 43.3609 124.168C43.3609 122.731 43.6595 121.452 44.2569 120.332C44.8729 119.212 45.7129 118.344 46.7769 117.728C47.8595 117.093 49.1289 116.776 50.5849 116.776C51.9475 116.776 53.1515 117.075 54.1969 117.672C55.2422 118.269 56.0542 119.091 56.6329 120.136C57.2302 121.163 57.5289 122.311 57.5289 123.58C57.5289 123.785 57.5195 124 57.5009 124.224C57.5009 124.448 57.4915 124.681 57.4729 124.924H46.9169C46.9915 126.007 47.3649 126.856 48.0369 127.472C48.7275 128.088 49.5582 128.396 50.5289 128.396C51.2569 128.396 51.8635 128.237 52.3489 127.92C52.8529 127.584 53.2262 127.155 53.4689 126.632H57.1089C56.8475 127.509 56.4089 128.312 55.7929 129.04C55.1955 129.749 54.4489 130.309 53.5529 130.72C52.6755 131.131 51.6769 131.336 50.5569 131.336ZM50.5849 119.688C49.7075 119.688 48.9329 119.94 48.2609 120.444C47.5889 120.929 47.1595 121.676 46.9729 122.684H53.8889C53.8329 121.769 53.4969 121.041 52.8809 120.5C52.2649 119.959 51.4995 119.688 50.5849 119.688ZM66.6192 131.336C65.3126 131.336 64.1459 131.019 63.1192 130.384C62.0926 129.749 61.2806 128.881 60.6832 127.78C60.0859 126.679 59.7872 125.428 59.7872 124.028C59.7872 122.628 60.0859 121.387 60.6832 120.304C61.2806 119.203 62.0926 118.344 63.1192 117.728C64.1459 117.093 65.3126 116.776 66.6192 116.776C67.6646 116.776 68.5792 116.972 69.3632 117.364C70.1472 117.756 70.7819 118.307 71.2672 119.016V110.84H74.8512V131H71.6592L71.2672 129.012C70.8192 129.628 70.2219 130.169 69.4752 130.636C68.7472 131.103 67.7952 131.336 66.6192 131.336ZM67.3752 128.2C68.5326 128.2 69.4752 127.817 70.2032 127.052C70.9499 126.268 71.3232 125.269 71.3232 124.056C71.3232 122.843 70.9499 121.853 70.2032 121.088C69.4752 120.304 68.5326 119.912 67.3752 119.912C66.2366 119.912 65.2939 120.295 64.5472 121.06C63.8006 121.825 63.4272 122.815 63.4272 124.028C63.4272 125.241 63.8006 126.24 64.5472 127.024C65.2939 127.808 66.2366 128.2 67.3752 128.2ZM82.9809 131.336C81.7862 131.336 80.8062 131.149 80.0409 130.776C79.2755 130.384 78.7062 129.871 78.3329 129.236C77.9595 128.601 77.7729 127.901 77.7729 127.136C77.7729 125.848 78.2769 124.803 79.2849 124C80.2929 123.197 81.8049 122.796 83.8209 122.796H87.3489V122.46C87.3489 121.508 87.0782 120.808 86.5369 120.36C85.9955 119.912 85.3235 119.688 84.5209 119.688C83.7929 119.688 83.1582 119.865 82.6169 120.22C82.0755 120.556 81.7395 121.06 81.6089 121.732H78.1089C78.2022 120.724 78.5382 119.847 79.1169 119.1C79.7142 118.353 80.4795 117.784 81.4129 117.392C82.3462 116.981 83.3915 116.776 84.5489 116.776C86.5275 116.776 88.0862 117.271 89.2249 118.26C90.3635 119.249 90.9329 120.649 90.9329 122.46V131H87.8809L87.5449 128.76C87.1342 129.507 86.5555 130.123 85.8089 130.608C85.0809 131.093 84.1382 131.336 82.9809 131.336ZM83.7929 128.536C84.8195 128.536 85.6129 128.2 86.1729 127.528C86.7515 126.856 87.1155 126.025 87.2649 125.036H84.2129C83.2609 125.036 82.5795 125.213 82.1689 125.568C81.7582 125.904 81.5529 126.324 81.5529 126.828C81.5529 127.369 81.7582 127.789 82.1689 128.088C82.5795 128.387 83.1209 128.536 83.7929 128.536ZM99.925 126.856C99.253 126.856 98.6277 126.781 98.049 126.632L97.013 127.668C97.3304 127.836 97.7597 127.976 98.301 128.088C98.8424 128.2 99.7197 128.312 100.933 128.424C102.781 128.592 104.125 129.031 104.965 129.74C105.805 130.449 106.225 131.429 106.225 132.68C106.225 133.501 106.001 134.276 105.553 135.004C105.105 135.751 104.414 136.348 103.481 136.796C102.548 137.263 101.353 137.496 99.897 137.496C97.9184 137.496 96.3224 137.123 95.109 136.376C93.8957 135.648 93.289 134.547 93.289 133.072C93.289 131.821 93.8957 130.739 95.109 129.824C94.7357 129.656 94.409 129.479 94.129 129.292C93.8677 129.105 93.6344 128.909 93.429 128.704V128.06L95.865 125.484C94.7824 124.532 94.241 123.309 94.241 121.816C94.241 120.883 94.465 120.033 94.913 119.268C95.3797 118.503 96.033 117.896 96.873 117.448C97.713 117 98.7304 116.776 99.925 116.776C100.709 116.776 101.437 116.888 102.109 117.112H107.373V119.296L104.993 119.464C105.366 120.173 105.553 120.957 105.553 121.816C105.553 122.749 105.329 123.599 104.881 124.364C104.433 125.129 103.78 125.736 102.921 126.184C102.081 126.632 101.082 126.856 99.925 126.856ZM99.925 124.112C100.653 124.112 101.25 123.916 101.717 123.524C102.202 123.132 102.445 122.572 102.445 121.844C102.445 121.116 102.202 120.556 101.717 120.164C101.25 119.772 100.653 119.576 99.925 119.576C99.1597 119.576 98.5437 119.772 98.077 120.164C97.6104 120.556 97.377 121.116 97.377 121.844C97.377 122.572 97.6104 123.132 98.077 123.524C98.5437 123.916 99.1597 124.112 99.925 124.112ZM96.565 132.708C96.565 133.399 96.8824 133.912 97.517 134.248C98.1704 134.603 98.9637 134.78 99.897 134.78C100.793 134.78 101.521 134.593 102.081 134.22C102.641 133.865 102.921 133.38 102.921 132.764C102.921 132.26 102.734 131.84 102.361 131.504C102.006 131.168 101.288 130.963 100.205 130.888C99.4397 130.832 98.7304 130.748 98.077 130.636C97.5357 130.935 97.1437 131.261 96.901 131.616C96.677 131.971 96.565 132.335 96.565 132.708ZM115.796 131.336C114.452 131.336 113.238 131.028 112.156 130.412C111.092 129.796 110.242 128.947 109.608 127.864C108.992 126.763 108.684 125.493 108.684 124.056C108.684 122.619 109.001 121.359 109.636 120.276C110.27 119.175 111.12 118.316 112.184 117.7C113.266 117.084 114.48 116.776 115.824 116.776C117.149 116.776 118.344 117.084 119.408 117.7C120.49 118.316 121.34 119.175 121.956 120.276C122.59 121.359 122.908 122.619 122.908 124.056C122.908 125.493 122.59 126.763 121.956 127.864C121.34 128.947 120.49 129.796 119.408 130.412C118.325 131.028 117.121 131.336 115.796 131.336ZM115.796 128.228C116.729 128.228 117.541 127.883 118.232 127.192C118.922 126.483 119.268 125.437 119.268 124.056C119.268 122.675 118.922 121.639 118.232 120.948C117.541 120.239 116.738 119.884 115.824 119.884C114.872 119.884 114.05 120.239 113.36 120.948C112.688 121.639 112.352 122.675 112.352 124.056C112.352 125.437 112.688 126.483 113.36 127.192C114.05 127.883 114.862 128.228 115.796 128.228ZM130.809 126.856C130.137 126.856 129.512 126.781 128.933 126.632L127.897 127.668C128.214 127.836 128.644 127.976 129.185 128.088C129.726 128.2 130.604 128.312 131.817 128.424C133.665 128.592 135.009 129.031 135.849 129.74C136.689 130.449 137.109 131.429 137.109 132.68C137.109 133.501 136.885 134.276 136.437 135.004C135.989 135.751 135.298 136.348 134.365 136.796C133.432 137.263 132.237 137.496 130.781 137.496C128.802 137.496 127.206 137.123 125.993 136.376C124.78 135.648 124.173 134.547 124.173 133.072C124.173 131.821 124.78 130.739 125.993 129.824C125.62 129.656 125.293 129.479 125.013 129.292C124.752 129.105 124.518 128.909 124.313 128.704V128.06L126.749 125.484C125.666 124.532 125.125 123.309 125.125 121.816C125.125 120.883 125.349 120.033 125.797 119.268C126.264 118.503 126.917 117.896 127.757 117.448C128.597 117 129.614 116.776 130.809 116.776C131.593 116.776 132.321 116.888 132.993 117.112H138.257V119.296L135.877 119.464C136.25 120.173 136.437 120.957 136.437 121.816C136.437 122.749 136.213 123.599 135.765 124.364C135.317 125.129 134.664 125.736 133.805 126.184C132.965 126.632 131.966 126.856 130.809 126.856ZM130.809 124.112C131.537 124.112 132.134 123.916 132.601 123.524C133.086 123.132 133.329 122.572 133.329 121.844C133.329 121.116 133.086 120.556 132.601 120.164C132.134 119.772 131.537 119.576 130.809 119.576C130.044 119.576 129.428 119.772 128.961 120.164C128.494 120.556 128.261 121.116 128.261 121.844C128.261 122.572 128.494 123.132 128.961 123.524C129.428 123.916 130.044 124.112 130.809 124.112ZM127.449 132.708C127.449 133.399 127.766 133.912 128.401 134.248C129.054 134.603 129.848 134.78 130.781 134.78C131.677 134.78 132.405 134.593 132.965 134.22C133.525 133.865 133.805 133.38 133.805 132.764C133.805 132.26 133.618 131.84 133.245 131.504C132.89 131.168 132.172 130.963 131.089 130.888C130.324 130.832 129.614 130.748 128.961 130.636C128.42 130.935 128.028 131.261 127.785 131.616C127.561 131.971 127.449 132.335 127.449 132.708ZM142.298 137.16L145.518 130.076H144.678L139.274 117.112H143.166L147.058 126.884L151.118 117.112H154.926L146.106 137.16H142.298Z",
    fill: "#FFB900"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M27.36 70V56H29.92V61.82H36.2V56H38.76V70H36.2V63.9H29.92V70H27.36ZM42.5811 58.54C42.1144 58.54 41.7278 58.4 41.4211 58.12C41.1278 57.84 40.9811 57.4867 40.9811 57.06C40.9811 56.6333 41.1278 56.2867 41.4211 56.02C41.7278 55.74 42.1144 55.6 42.5811 55.6C43.0478 55.6 43.4278 55.74 43.7211 56.02C44.0278 56.2867 44.1811 56.6333 44.1811 57.06C44.1811 57.4867 44.0278 57.84 43.7211 58.12C43.4278 58.4 43.0478 58.54 42.5811 58.54ZM41.3011 70V60.08H43.8611V70H41.3011ZM50.5131 67.04C50.0331 67.04 49.5865 66.9867 49.1731 66.88L48.4331 67.62C48.6598 67.74 48.9665 67.84 49.3531 67.92C49.7398 68 50.3665 68.08 51.2331 68.16C52.5531 68.28 53.5131 68.5933 54.1131 69.1C54.7131 69.6067 55.0131 70.3067 55.0131 71.2C55.0131 71.7867 54.8531 72.34 54.5331 72.86C54.2131 73.3933 53.7198 73.82 53.0531 74.14C52.3865 74.4733 51.5331 74.64 50.4931 74.64C49.0798 74.64 47.9398 74.3733 47.0731 73.84C46.2065 73.32 45.7731 72.5333 45.7731 71.48C45.7731 70.5867 46.2065 69.8133 47.0731 69.16C46.8065 69.04 46.5731 68.9133 46.3731 68.78C46.1865 68.6467 46.0198 68.5067 45.8731 68.36V67.9L47.6131 66.06C46.8398 65.38 46.4531 64.5067 46.4531 63.44C46.4531 62.7733 46.6131 62.1667 46.9331 61.62C47.2665 61.0733 47.7331 60.64 48.3331 60.32C48.9331 60 49.6598 59.84 50.5131 59.84C51.0731 59.84 51.5931 59.92 52.0731 60.08H55.8331V61.64L54.1331 61.76C54.3998 62.2667 54.5331 62.8267 54.5331 63.44C54.5331 64.1067 54.3731 64.7133 54.0531 65.26C53.7331 65.8067 53.2665 66.24 52.6531 66.56C52.0531 66.88 51.3398 67.04 50.5131 67.04ZM50.5131 65.08C51.0331 65.08 51.4598 64.94 51.7931 64.66C52.1398 64.38 52.3131 63.98 52.3131 63.46C52.3131 62.94 52.1398 62.54 51.7931 62.26C51.4598 61.98 51.0331 61.84 50.5131 61.84C49.9665 61.84 49.5265 61.98 49.1931 62.26C48.8598 62.54 48.6931 62.94 48.6931 63.46C48.6931 63.98 48.8598 64.38 49.1931 64.66C49.5265 64.94 49.9665 65.08 50.5131 65.08ZM48.1131 71.22C48.1131 71.7133 48.3398 72.08 48.7931 72.32C49.2598 72.5733 49.8265 72.7 50.4931 72.7C51.1331 72.7 51.6531 72.5667 52.0531 72.3C52.4531 72.0467 52.6531 71.7 52.6531 71.26C52.6531 70.9 52.5198 70.6 52.2531 70.36C51.9998 70.12 51.4865 69.9733 50.7131 69.92C50.1665 69.88 49.6598 69.82 49.1931 69.74C48.8065 69.9533 48.5265 70.1867 48.3531 70.44C48.1931 70.6933 48.1131 70.9533 48.1131 71.22ZM57.4798 70V55.6H60.0398V61.6C60.3732 61.0533 60.8198 60.6267 61.3798 60.32C61.9532 60 62.6065 59.84 63.3398 59.84C64.5665 59.84 65.5132 60.2267 66.1798 61C66.8598 61.7733 67.1998 62.9067 67.1998 64.4V70H64.6598V64.64C64.6598 63.7867 64.4865 63.1333 64.1398 62.68C63.8065 62.2267 63.2732 62 62.5398 62C61.8198 62 61.2198 62.2533 60.7398 62.76C60.2732 63.2667 60.0398 63.9733 60.0398 64.88V70H57.4798ZM80.5934 70.24C79.1934 70.24 77.9668 69.9333 76.9134 69.32C75.8734 68.7067 75.0534 67.86 74.4534 66.78C73.8668 65.6867 73.5734 64.4267 73.5734 63C73.5734 61.5733 73.8668 60.32 74.4534 59.24C75.0534 58.1467 75.8734 57.2933 76.9134 56.68C77.9668 56.0667 79.1934 55.76 80.5934 55.76C81.9801 55.76 83.2001 56.0667 84.2534 56.68C85.3068 57.2933 86.1268 58.1467 86.7134 59.24C87.3001 60.32 87.5934 61.5733 87.5934 63C87.5934 64.3333 87.3334 65.5267 86.8134 66.58C86.2934 67.62 85.5734 68.4467 84.6534 69.06L87.8934 72.54H84.7134L82.5134 70.02C81.9001 70.1667 81.2601 70.24 80.5934 70.24ZM80.5934 67.94C81.9268 67.94 82.9868 67.5 83.7734 66.62C84.5734 65.74 84.9734 64.5333 84.9734 63C84.9734 61.4667 84.5734 60.26 83.7734 59.38C82.9868 58.5 81.9268 58.06 80.5934 58.06C79.2601 58.06 78.1934 58.5 77.3934 59.38C76.5934 60.26 76.1934 61.4667 76.1934 63C76.1934 64.5333 76.5934 65.74 77.3934 66.62C78.1934 67.5 79.2601 67.94 80.5934 67.94ZM93.45 70.24C92.21 70.24 91.25 69.8533 90.57 69.08C89.9033 68.3067 89.57 67.1733 89.57 65.68V60.08H92.11V65.44C92.11 66.2933 92.2833 66.9467 92.63 67.4C92.9767 67.8533 93.5233 68.08 94.27 68.08C94.9767 68.08 95.5567 67.8267 96.01 67.32C96.4767 66.8133 96.71 66.1067 96.71 65.2V60.08H99.27V70H97.01L96.81 68.32C96.5033 68.9067 96.0567 69.3733 95.47 69.72C94.8967 70.0667 94.2233 70.24 93.45 70.24ZM105.098 70.24C104.245 70.24 103.545 70.1067 102.998 69.84C102.451 69.56 102.045 69.1933 101.778 68.74C101.511 68.2867 101.378 67.7867 101.378 67.24C101.378 66.32 101.738 65.5733 102.458 65C103.178 64.4267 104.258 64.14 105.698 64.14H108.218V63.9C108.218 63.22 108.025 62.72 107.638 62.4C107.251 62.08 106.771 61.92 106.198 61.92C105.678 61.92 105.225 62.0467 104.838 62.3C104.451 62.54 104.211 62.9 104.118 63.38H101.618C101.685 62.66 101.925 62.0333 102.338 61.5C102.765 60.9667 103.311 60.56 103.978 60.28C104.645 59.9867 105.391 59.84 106.218 59.84C107.631 59.84 108.745 60.1933 109.558 60.9C110.371 61.6067 110.778 62.6067 110.778 63.9V70H108.598L108.358 68.4C108.065 68.9333 107.651 69.3733 107.118 69.72C106.598 70.0667 105.925 70.24 105.098 70.24ZM105.678 68.24C106.411 68.24 106.978 68 107.378 67.52C107.791 67.04 108.051 66.4467 108.158 65.74H105.978C105.298 65.74 104.811 65.8667 104.518 66.12C104.225 66.36 104.078 66.66 104.078 67.02C104.078 67.4067 104.225 67.7067 104.518 67.92C104.811 68.1333 105.198 68.24 105.678 68.24ZM113.001 70V55.6H115.561V70H113.001ZM119.337 58.54C118.87 58.54 118.483 58.4 118.177 58.12C117.883 57.84 117.737 57.4867 117.737 57.06C117.737 56.6333 117.883 56.2867 118.177 56.02C118.483 55.74 118.87 55.6 119.337 55.6C119.803 55.6 120.183 55.74 120.477 56.02C120.783 56.2867 120.937 56.6333 120.937 57.06C120.937 57.4867 120.783 57.84 120.477 58.12C120.183 58.4 119.803 58.54 119.337 58.54ZM118.057 70V60.08H120.617V70H118.057ZM127.489 70C126.449 70 125.615 69.7467 124.989 69.24C124.362 68.7333 124.049 67.8333 124.049 66.54V62.22H122.349V60.08H124.049L124.349 57.42H126.609V60.08H129.289V62.22H126.609V66.56C126.609 67.04 126.709 67.3733 126.909 67.56C127.122 67.7333 127.482 67.82 127.989 67.82H129.229V70H127.489ZM132.507 74.4L134.807 69.34H134.207L130.347 60.08H133.127L135.907 67.06L138.807 60.08H141.527L135.227 74.4H132.507Z",
    fill: "#FFB900"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M66.401 27.2779L67.8546 26.815L66.622 23.0973L69.1637 22.2885L68.6914 20.8636L64.6961 22.1364L66.401 27.279V27.2779ZM56.8814 17.9355L57.3537 16.5106L61.1464 17.7188L62.379 14L63.8327 14.4629L62.1279 19.6054L56.8814 17.9344V17.9355ZM65.9322 27.5059L64.695 28.3874L62.3513 25.2245L56.7449 28.6676L52.6153 31.4573L56.8479 25.2233L58.9659 21.8993L55.7391 19.602L56.6384 18.3893L61.1013 21.5681L57.1095 27.051L62.6881 23.1302L65.9311 27.5048L65.9322 27.5059Z",
    fill: "white"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5538 14.5604H67.0306C67.394 14.5604 67.7239 14.6047 68.0213 14.6943C68.3188 14.7828 68.5711 14.9133 68.7806 15.0823C68.99 15.2525 69.1509 15.4612 69.2632 15.7097C69.3755 15.9581 69.4322 16.2383 69.4322 16.5514V16.5673C69.4322 16.902 69.3697 17.1958 69.247 17.4488C69.1231 17.7029 68.9507 17.9151 68.7308 18.0875C68.5109 18.2599 68.2482 18.3893 67.9426 18.4755C67.6371 18.5617 67.306 18.6048 66.9484 18.6048H66.1556V20.2237H64.5538V14.5604ZM66.9149 17.3762C67.2007 17.3762 67.4253 17.3104 67.5873 17.1765C67.7493 17.0438 67.8303 16.8634 67.8303 16.6354V16.6195C67.8303 16.3756 67.7493 16.1895 67.5873 16.0625C67.4253 15.9354 67.1973 15.8707 66.9067 15.8707H66.1556V17.3762H66.9149Z",
    fill: "white"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M26 31.6978H31.2731C32.0462 31.6978 32.7499 31.7919 33.383 31.9825C34.0161 32.172 34.5543 32.4477 34.9999 32.8096C35.4454 33.1715 35.788 33.6173 36.0276 34.1448C36.2672 34.6735 36.3876 35.2702 36.3876 35.9362V35.9702C36.3876 36.6827 36.2556 37.3089 35.9917 37.8478C35.7279 38.3878 35.3621 38.8416 34.8934 39.2091C34.4246 39.5767 33.8656 39.8524 33.2152 40.0362C32.5647 40.2199 31.8587 40.3118 31.0971 40.3118H29.4097V43.7584H26V31.6966V31.6978ZM31.0277 37.6935C31.6365 37.6935 32.1145 37.5517 32.4605 37.2692C32.8066 36.9867 32.9791 36.6021 32.9791 36.1165V36.0814C32.9791 35.5618 32.8054 35.1659 32.4605 34.8947C32.1145 34.6236 31.6319 34.4874 31.0103 34.4874H29.4108V37.6923H31.0277V37.6935Z",
    fill: "white"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8297 31.6978H43.6479C44.5969 31.6978 45.4002 31.8124 46.0564 32.0427C46.7126 32.273 47.2462 32.594 47.6559 33.007C48.3827 33.6967 48.7462 34.6327 48.7462 35.8159V35.8499C48.7462 36.7802 48.5182 37.5505 48.061 38.1586C47.6038 38.7678 46.9892 39.2329 46.215 39.554L49.1501 43.7584H45.2127L42.7347 40.1054H41.2405V43.7584H37.8308V31.6966L37.8297 31.6978ZM43.4905 37.487C44.0761 37.487 44.5275 37.3577 44.8434 37.099C45.1594 36.8403 45.318 36.4932 45.318 36.0564V36.0224C45.318 35.5402 45.1536 35.1806 44.8261 34.9458C44.4974 34.7109 44.0472 34.593 43.4731 34.593H41.2405V37.4881H43.4905V37.487Z",
    fill: "white"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6558 44C55.7067 44 54.8271 43.8366 54.0192 43.5088C53.2114 43.1809 52.5135 42.7362 51.9278 42.1735C51.3422 41.6108 50.8815 40.9505 50.5482 40.1916C50.2137 39.4337 50.0471 38.6237 50.0471 37.7627V37.7286C50.0471 36.8676 50.2137 36.0542 50.5482 35.2907C50.8827 34.5272 51.348 33.8601 51.9452 33.2917C52.5424 32.7233 53.2461 32.2752 54.0551 31.9474C54.8641 31.6195 55.7426 31.4561 56.6916 31.4561C57.6407 31.4561 58.5203 31.6195 59.3282 31.9474C60.1372 32.2752 60.8339 32.7199 61.4196 33.2826C62.0052 33.8453 62.4659 34.5056 62.7992 35.2646C63.1325 36.0235 63.3003 36.8324 63.3003 37.6935V37.7275C63.3003 38.5886 63.1337 39.402 62.7992 40.1655C62.4647 40.9301 61.9994 41.5961 61.4022 42.1644C60.805 42.7328 60.1013 43.1809 59.2923 43.5088C58.4833 43.8366 57.6048 44 56.6558 44ZM56.6824 40.9846C57.1523 40.9846 57.5817 40.8984 57.9694 40.7259C58.3571 40.5535 58.6858 40.3209 58.9566 40.0282C59.2263 39.7355 59.4381 39.394 59.5909 39.0026C59.7437 38.6124 59.8201 38.1983 59.8201 37.7627V37.7286C59.8201 37.2919 59.7437 36.8789 59.5909 36.4875C59.4381 36.0973 59.2205 35.7524 58.9393 35.454C58.6569 35.1556 58.3224 34.9174 57.9347 34.7393C57.5469 34.5612 57.1176 34.4727 56.6477 34.4727C56.1778 34.4727 55.7518 34.5589 55.3699 34.7314C54.988 34.9038 54.6593 35.1364 54.3826 35.4291C54.106 35.7218 53.8954 36.0644 53.7484 36.4546C53.6014 36.8449 53.5285 37.259 53.5285 37.6946V37.7286C53.5285 38.1654 53.6049 38.5784 53.7577 38.9686C53.9104 39.3589 54.1245 39.7038 54.4012 40.0021C54.6766 40.3005 55.0088 40.5387 55.3965 40.7168C55.7842 40.8949 56.2136 40.9834 56.6835 40.9834L56.6824 40.9846Z",
    fill: "white"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0758 31.6978H70.3488C71.122 31.6978 71.8256 31.7919 72.4587 31.9825C73.0918 32.1731 73.63 32.4477 74.0756 32.8096C74.5212 33.1715 74.8638 33.6173 75.1034 34.1448C75.343 34.6735 75.4633 35.2702 75.4633 35.9362V35.9702C75.4633 36.6827 75.3314 37.3089 75.0675 37.8478C74.8036 38.3878 74.4379 38.8416 73.9691 39.2091C73.5004 39.5767 72.9414 39.8524 72.2909 40.0362C71.6405 40.2199 70.9345 40.3118 70.1729 40.3118H68.4854V43.7584H65.0758V31.6966V31.6978ZM70.1035 37.6935C70.7122 37.6935 71.1902 37.5517 71.5363 37.2692C71.8824 36.9867 72.0548 36.6021 72.0548 36.1165V36.0814C72.0548 35.5618 71.8812 35.1659 71.5363 34.8947C71.1902 34.6236 70.7065 34.4874 70.0861 34.4874H68.4866V37.6923H70.1035V37.6935Z",
    fill: "white"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9066 31.6978H86.7861V34.5408H80.2642V36.3673H86.1703V39.0038H80.2642V40.9165H86.874V43.7595H76.9066V31.6978Z",
    fill: "white"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6309 31.6978H92.0406V40.8303H98V43.7595H88.6309V31.6978Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_10512_4421)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 148,
    width: 48,
    height: 28,
    rx: 14,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 148,
    width: 48,
    height: 28,
    rx: 14,
    fill: "url(#paint43_linear_10512_4421)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 148,
    width: 48,
    height: 28,
    rx: 14,
    fill: "url(#paint44_linear_10512_4421)"
  }))), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6979 166.899C51.3941 166.595 51.3941 166.105 51.6979 165.802L54.7124 162.776H42.8958C42.4674 162.776 42.1168 162.426 42.1168 161.999C42.1168 161.571 42.4674 161.221 42.8958 161.221H54.7124L51.6901 158.203C51.3863 157.9 51.3863 157.41 51.6901 157.106C51.9939 156.803 52.4846 156.803 52.7884 157.106L57.1505 161.454C57.4543 161.758 57.4543 162.248 57.1505 162.551L52.7962 166.899C52.4924 167.194 51.9939 167.194 51.6979 166.899Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10512_4421",
    x: 0,
    y: 0,
    width: 386,
    height: 198,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10512_4421"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10512_4421",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_10512_4421",
    x: 18,
    y: 140,
    width: 64,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10512_4421"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10512_4421",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10512_4421",
    x1: 224.636,
    y1: 93.8699,
    x2: 224.636,
    y2: 166.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35A3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#339999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#2E8183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C767A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10512_4421",
    x1: 204.735,
    y1: 92.5141,
    x2: 204.735,
    y2: 165.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35A3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#339999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#2E8183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C767A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10512_4421",
    x1: 214.458,
    y1: 109.462,
    x2: 214.458,
    y2: 178.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35A3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#339999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#2E8183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C767A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10512_4421",
    x1: 232.627,
    y1: 114.102,
    x2: 232.627,
    y2: 177.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35A3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#339999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#2E8183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C767A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10512_4421",
    x1: 196.539,
    y1: 121.848,
    x2: 196.539,
    y2: 175.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35A3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#339999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#2E8183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C767A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10512_4421",
    x1: 214.577,
    y1: 164.3,
    x2: 214.577,
    y2: 191.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60578F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10512_4421",
    x1: 366.451,
    y1: 115.988,
    x2: 298.238,
    y2: 115.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10512_4421",
    x1: 329.267,
    y1: 182.204,
    x2: 329.267,
    y2: 159.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_10512_4421",
    x1: 329.267,
    y1: 71.5837,
    x2: 329.267,
    y2: 154.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67C8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#499EB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3581A7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_10512_4421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(333.309 104.622) rotate(-180) scale(50.7237 51.1707)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFE643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B6DC41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9DC43D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97BD3C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_10512_4421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(333.309 104.623) rotate(-180) scale(50.7237 51.1707)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFE643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B6DC41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9DC43D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97BD3C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_10512_4421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(333.309 104.623) rotate(-180) scale(50.7237 51.1707)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFE643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B6DC41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9DC43D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97BD3C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_10512_4421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(333.309 104.622) rotate(-180) scale(50.7237 51.1706)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFE643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B6DC41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9DC43D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97BD3C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_10512_4421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(333.309 104.623) rotate(-180) scale(50.7237 51.1707)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFE643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B6DC41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9DC43D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97BD3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_10512_4421",
    x1: 363.056,
    y1: 185.132,
    x2: 295.478,
    y2: 185.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_10512_4421",
    x1: 378.502,
    y1: 120.141,
    x2: 294.425,
    y2: 120.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_10512_4421",
    x1: 231.438,
    y1: 148.027,
    x2: 231.579,
    y2: 195.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB945B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_10512_4421",
    x1: 371.676,
    y1: 185.496,
    x2: 374.073,
    y2: 194.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_10512_4421",
    x1: 373.655,
    y1: 185.229,
    x2: 373.683,
    y2: 194.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_10512_4421",
    x1: 371.683,
    y1: 185.49,
    x2: 374.079,
    y2: 194.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_10512_4421",
    x1: 360.413,
    y1: 86.8123,
    x2: 360.727,
    y2: 191.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB945B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_10512_4421",
    x1: 320.586,
    y1: 183.639,
    x2: 315.739,
    y2: 200.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_10512_4421",
    x1: 319.233,
    y1: 188.42,
    x2: 315.667,
    y2: 200.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_10512_4421",
    x1: 331.951,
    y1: 86.8979,
    x2: 332.265,
    y2: 191.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB945B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_10512_4421",
    x1: 346.891,
    y1: 77.7363,
    x2: 346.941,
    y2: 94.6958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_10512_4421",
    x1: 346.915,
    y1: 86.8533,
    x2: 347.229,
    y2: 191.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB945B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_10512_4421",
    x1: 346.927,
    y1: 90.964,
    x2: 346.961,
    y2: 102.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_10512_4421",
    x1: 323.788,
    y1: 146.716,
    x2: 323.93,
    y2: 194.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60578F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_10512_4421",
    x1: 318.447,
    y1: 146.732,
    x2: 318.589,
    y2: 194.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60578F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_10512_4421",
    x1: 350.362,
    y1: 146.636,
    x2: 350.504,
    y2: 194.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60578F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_10512_4421",
    x1: 285.278,
    y1: 149.512,
    x2: 285.331,
    y2: 167.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#56ACB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_10512_4421",
    x1: 261.062,
    y1: 149.583,
    x2: 261.115,
    y2: 167.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#56ACB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_10512_4421",
    x1: 285.247,
    y1: 138.949,
    x2: 285.279,
    y2: 149.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_10512_4421",
    x1: 265.494,
    y1: 139.008,
    x2: 265.527,
    y2: 149.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_10512_4421",
    x1: 285.328,
    y1: 166.51,
    x2: 285.413,
    y2: 195.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_10512_4421",
    x1: 331.615,
    y1: 135.995,
    x2: 331.615,
    y2: 195.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#56ACB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_10512_4421",
    x1: 331.615,
    y1: 137.595,
    x2: 331.615,
    y2: 194.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#56ACB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_10512_4421",
    x1: 331.615,
    y1: 135.996,
    x2: 331.615,
    y2: 195.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_10512_4421",
    x1: 331.615,
    y1: 135.995,
    x2: 331.615,
    y2: 195.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_10512_4421",
    x1: 331.615,
    y1: 135.996,
    x2: 331.615,
    y2: 195.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_10512_4421",
    x1: 331.615,
    y1: 135.995,
    x2: 331.615,
    y2: 195.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_10512_4421",
    x1: 331.554,
    y1: 149.596,
    x2: 331.554,
    y2: 166.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_10512_4421",
    x1: 331.624,
    y1: 179.485,
    x2: 331.624,
    y2: 190.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_10512_4421",
    x1: 74,
    y1: 176,
    x2: 23.5788,
    y2: 170.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_10512_4421",
    x1: 50,
    y1: 108.042,
    x2: 50,
    y2: 176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDA44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5F00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10512_4421"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 382,
    height: 194,
    rx: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCp);
export default __webpack_public_path__ + "static/media/CP.af0aa8a1cb3e6dbade2069d012d059a1.svg";
export { ForwardRef as ReactComponent };